import React, { useEffect, useRef, useState } from 'react';
import BadgesComponent from "@components/common/Badges";
import DataTable from '@components/common/CommonDataTable';
import HealthProviderAction from "./HealthProviderModal";
import './overview.css'
import Button from "@components/common/Button";
import { coverageShiftTransfer, dateFormate, facilityDetailsForHealthProvider, facilityDetailsForHealthProviderTransfer, updateLinkedFacilityData } from '@constants/index';
import CommonFormFields from '@pages/Forms/CommonFormFields';
import endpoints from '@config/endpoints';
import { getData, getDataParams, getDataWithCache, postDataJSON, putDataJSON } from '../../../services/CommonApiService';
import { useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import LinkedUnLinkedShow from './linkedUnLinkedShow';
import { RootState } from '@store/reducers';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';
import { updateForm } from '@store/actions/userManagementAction';
import axios from '../../../utils/axiosExt';
import { toast } from 'react-toastify';
import TooltipComponent from '@components/common/TooltipComponent';
import { PagePermission } from '../../../services/usePermission';
import Auth from '../../../utils/auth';
import { errorLogger } from '@utils/applicationLogUtils';
import isUsingGramPanchayatUtils from '@utils/isUsingGrampanchayatUtil';
import _ from 'lodash';
import { decodeWithKeyAndShift } from '@utils/base64Utils';
import { USER_TYPES } from '@constants/userTypes';
import { checkUserRole, errorSuccessMessage, roleType, setStatusMessage } from '@constants/approvalConstants';

interface objectTypes {
  isError: boolean,
  message: string,
  isDisable: boolean,
  value: any,
  id?: any,
  verifiedDetails?: any
  code?: number
}

interface formStateType {
  [key: string]: objectTypes
}

interface formDataType {
  [key: string]: any;
}

const UserManagementHealthProvider = () => {
  const canCreateUser = PagePermission("UserMgmt_HPM", "HPM_LinkPg");
  const canEditUser = PagePermission("UserMgmt_HPM", "HPM_SftPg");
  const healthProviderObj = {
    hfr_id: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
    health_facility_type: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: ''
    },
    health_facility_name: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: ''
    },
    mobiliser_tagged: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: ''
    },
    wards_covered: {
      isError: false,
      message: '',
      isDisable: false,
      value: [],
      id: [],
      code: undefined
    },
    villages_covered: {
      isError: false,
      message: '',
      isDisable: false,
      value: [],
      id: [],
      code: undefined
    },
    gram_panchayat_covered: {
      isError: false,
      message: '',
      isDisable: false,
      value: [],
      id: [],
      code: undefined
    },
    effective_from_date: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
    remarks: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    }
  }

  const coverageShiftTransferObj = {
    hfr_id: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
    health_facility_type: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: ''
    },
    health_facility_name: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: ''
    },
    mobiliser_tagged: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
    wards_covered: {
      isError: false,
      message: '',
      isDisable: false,
      value: [],
      id: [],
      code: undefined
    },
    villages_covered: {
      isError: false,
      message: '',
      isDisable: false,
      value: [],
      id: [],
      code: undefined
    },
    gram_panchayat_covered: {
      isError: false,
      message: '',
      isDisable: false,
      value: [],
      id: [],
      code: undefined
    },
  }
  const shiftTransferObj = {
    villagesAndwards: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: '',
      code: undefined
    },
    rural_urban: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: '',
      code: undefined
    },
    effective_from_date: {
      isError: false,
      message: '',
      isDisable: false,
      value: false,
    },
    state: {
      isError: false,
      message: '',
      isDisable: true,
      value: '',
      id: '',
      code: undefined
    },
    district: {
      isError: false,
      message: '',
      isDisable: true,
      value: '',
      id: '',
      code: undefined
    },
    sub_district: {
      value: '',
    },
    remarks: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: '',
      code: undefined
    },
    block: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: '',
      code: undefined
    },
    health_block: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: '',
      code: undefined
    },
    sub_division: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: '',
      code: undefined
    },
    village: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: '',
      code: undefined
    },
    gram_panchayat: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: '',
      code: undefined
    },
    ward: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: '',
      code: undefined
    },
    ulb: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: '',
      code: undefined
    }
  }
  const [linkedFacilityData, setLinkedFacilityData] = useState<formDataType>(updateLinkedFacilityData);
  const [linkedFacilityForm, setLinkedFacilityForm] = useState<formStateType>({
    hfr_id: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
    health_facility_type: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: ''
    },
    health_facility_name: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: ''
    },
    mobiliser_tagged: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
    wards_covered: {
      isError: false,
      message: '',
      isDisable: false,
      value: [],
      id: [],
      code: undefined
    },
    villages_covered: {
      isError: false,
      message: '',
      isDisable: false,
      value: [],
      id: [],
      code: undefined
    },
    gram_panchayat_covered: {
      isError: false,
      message: '',
      isDisable: false,
      value: [],
      id: [],
      code: undefined
    },
    effective_from_date: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
    remarks: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    }
  });
  const [isSubmitButtonClicked, setIsSubmitButtonCLicked] = useState<boolean>(false);
  const [showMultipleFacilities, setShowMultipleFacilities] = useState(false);
  const [linkedFacility, setLinkedFacility] = useState<any>({});
  const [userDetails, setUserDetails] = useState<any>([]);
  const [isGrampanchayat, setIsGrampanchayat] = useState<boolean>(false);
  const [linkedFacilitiesCount, setLinkedFacilitiesCount] = useState<any>(0);
  const [isLinkingMultipleFacilities, setIsLinkingMultipleFacilities] = useState(false);
  const [facilityDetails1, setFacilityDetails1] = useState<any[]>();
  const [villageAndWardDetails, setVillageAndWardDetails] = useState<any[]>();
  const [mobiliserTaggedDetails, setMobiliserTaggedDetails] = useState<any[]>();
  const [showShiftTransfer, setShowShiftTransfer] = useState(false);
  const [showEditLinkedFacility, setShowEditLinkedFacility] = useState(false);
  const [facilityDetails, setFacilityDetails] = useState<any>([]);
  const [shiftTransferForm, setShiftTransferForm] = useState<formDataType>(shiftTransferObj);
  const [coverageShiftTransferData, setCoverageShiftTransferData] = useState<formDataType>(coverageShiftTransfer);
  const [coverageShiftTransferForm, setCoverageShiftTransferForm] = useState<formStateType>(coverageShiftTransferObj);
  const { id } = useParams();
  const [isShowLinkedFacilityEnabled, setIsShowLinkedFacilityEnabled] = useState<boolean>(false);
  const [isShowShiftTransferEnabled, setIsShowShiftTransferEnabled] = useState<boolean>(false);
  const [isFacilityOrFieldUser, setIsFacilityOrFieldUser] = useState<string>('');
  const [shiftTransferData, setShiftTransferData] = useState<formDataType>(facilityDetailsForHealthProviderTransfer);
  const [healthProviderData, setHealthProviderData] = useState<formDataType>(facilityDetailsForHealthProvider);
  const [healthProviderForm, setHealthProviderForm] = useState<formStateType>(healthProviderObj);
  //shift transfer
  const [shiftTransferStates, setShiftTransferStates] = useState<any>()
  const [shiftTransferDistricts, setShiftTransferDistricts] = useState<any>()
  const [shiftTransferSubDistricts, setShiftTransferSubDistricts] = useState<any>()
  const [shiftTransferBlocks, setShiftTransferBlocks] = useState<any>()
  const [shiftTransferULBs, setShiftTransferULBs] = useState<any>();
  const [shiftTransferRuralUrban, setShiftTransferRuralUrban] = useState<any>();
  const [shiftTransferRuralUrbanId, setShiftTransferRuralUrbanId] = useState<any>();
  const unlinkPayload = useSelector((state: RootState) => state.user.unlinkPayload);
  const isEditButtonCLicked = useSelector((state: RootState) => state.user.isEditButtonCLicked);
  const isFacilityDeleted = useSelector((state: RootState) => state.user.isFacilityDeleted);
  const isUserActive = useSelector((state: RootState) => state.user.isUserActive);
  const navigateShiftTransfer = useSelector((state: RootState) => state.user.navigateShiftTransfer);
  const navigateLinkPayload = useSelector((state: RootState) => state.user.navigateLinkPayload);
  const isLinkUnLinkButtonCLicked = useSelector((state: RootState) => state.user.isLinkUnLinkButtonCLicked);
  const linkedFacilityId = useSelector((state: RootState) => state.user.linkedFacilityId);
  const [ulbInputText, setUlbInputText] = useState<string>('');
  const [disableShiftTransferBtn, setDisableShiftTransferBtn] = useState<boolean>(false);
  const [approvalReqId, setApprovalReqId] = useState('');
  const [approvalReqStatus, setApprovalReqStatus] = useState('');
  const [reqefectiveData, setReqefectiveData] = useState('');
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const encodedUserData = localStorage.getItem('userDetails');
  const LogedinUserDetails: any = encodedUserData ? JSON.parse(decodeWithKeyAndShift(encodedUserData)) : '';
  const encodedUserRoles = localStorage.getItem('userRoleDetails');
  const userRolesDetails = encodedUserRoles ? JSON.parse(decodeWithKeyAndShift(encodedUserRoles)).split(', ') : [];
  const roleData = checkUserRole(userRolesDetails)

  const idCodeSet = (option: any, value: any) => {
    const id: any[] = [];
    option.length > 0 && value.length > 0 && option.forEach((op: any) => {
      if (value.includes(op.value)) {
        id.push(op.id);
      }
    });
    const code: any[] = [];
    option.length > 0 && value.length > 0 && option.forEach((op: any) => {
      if (value.includes(op.value)) {
        code.push(op.code);
      }
    });

    return {
      code: code,
      id: id
    }
  }
  function handleEditFormChange(value: any, key: string, field?: formDataType | undefined, option?: any, code?: any, id?: any): void {
    if (key === 'villages_covered'||key==='wards_covered'|| key==='gram_panchayat_covered' || key === 'mobiliser_tagged') {
      const data = idCodeSet(option, value)
      id = data.id
      code = data.code
    } else if (value && key === 'remarks' && value.length > 30) {
      return;
    }
    setLinkedFacilityForm((prevState: any) => ({
      ...prevState,
      [key]: {
        ...prevState[key],
        value: value,
        isError: false,
        message: '',
        id: id,
        code: code
      },
    }));
  }

  const renderStar = (props: any) => {
    return (
      <TooltipComponent text={'Parent Facility'} >
        {<div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "5px" }}>
          <div>{props.user?.facility_name?.value}</div>
          <div className='user-mgmt-health-provider-star'>*</div>
        </div>}
      </TooltipComponent>
    )
  }

  const constructActionData = (dataList: any) => {
    return dataList.map((data: any, index: number) => {
      return {
        ...data,
        facility_name: {
          value: data.facility_name !== null ? data.facility_name : '-----',
          isLinked: data.is_linked,
          type: 'component',
          isParent: data.is_parent ? true : false,
          component: data.is_parent ? renderStar : LinkedUnLinkedShow,

        },
        facility_type_name: data.facility_type_name !== null ? data.facility_type_name : '-----',
        hfr_id: data.hfr_id !== null ? data.hfr_id : '-----',
        health_provider_name:data?.healthprovider_details!==null?data?.healthprovider_details?.map((hp:any) => hp?.healthprovider_name)?.join(', '):'-----',
        mobiliser_name:data?.mobiliser_details!==null?data?.mobiliser_details?.map((mb:any) => mb?.mobiliser_name)?.join(', '):'-----',
        effective_from_dt: data.effective_from_dt !== null ? dayjs(data.effective_from_dt).format('DD-MM-YYYY') : '-----',
        effective_dt: data.effective_from_dt !== null ? dayjs(data.effective_from_dt).format('DD-MM-YYYY') : '-----',
        effective_from_dtUse: data.effective_from_dt !== null ? data.effective_from_dt : null,
        effective_to_dt: data.effective_to_dt !== null ? dayjs(data.effective_to_dt).format('DD-MM-YYYY') : '-----',
        effective_to_dtUse: data.effective_to_dt !== null ? data.effective_to_dt : null,
        Action: {
          type: 'component',
          setShowEditLinkedFacility: setShowEditLinkedFacility,
          component: HealthProviderAction,
        },
      };
    });
  };


  const fetchLinkedFacilitiesByUserId = async (userId: any) => {
    const healthProviderDataFetch = await getData<any[]>(`${endpoints.getLinkedFacilitiesByUser(userId)}`);
    setLinkedFacility(healthProviderDataFetch.data[0][0]);
  }
  useEffect(() => {
    if (linkedFacilityId !== '' && showEditLinkedFacility) {
      fetchLinkedFacilitiesByUserId(linkedFacilityId);
      if(isGrampanchayat){
        setLinkedFacilityData((prevState) => ({
          ...prevState,
          gram_panchayat_covered: {
            ...prevState['gram_panchayat_covered'],
            '#isVisible': true
          },        
        }))
      }
      else{
        setLinkedFacilityData((prevState) => ({
          ...prevState,
          villages_covered: {
            ...prevState['villages_covered'],
            '#isVisible': true
          },        
        }))
      }
      if(userDetails?.urban_rural_name === 'urban'){
        setLinkedFacilityData((prevState) => ({
          ...prevState,
          wards_covered: {
            ...prevState['wards_covered'],
            '#isDisabled': false
          },        
        }))
      }
      else{
        if(isGrampanchayat){
          setLinkedFacilityData((prevState) => ({
            ...prevState,
            gram_panchayat_covered: {
              ...prevState['gram_panchayat_covered'],
              '#isDisabled': false,
              '#isVisible': true
            },        
          }))
        }
        else{
          setLinkedFacilityData((prevState) => ({
            ...prevState,
            villages_covered: {
              ...prevState['villages_covered'],
              '#isDisabled': false,
              '#isVisible': true
            },        
          }))
        }
      }
      setLinkedFacilityData((prevState) => ({
        ...prevState,
        hfr_id: {
          ...prevState['hfr_id'],
          '#isDisabled': true
        },
        health_facility_type: {
          ...prevState['health_facility_type'],
          '#isDisabled': true
        },
        health_facility_name: {
          ...prevState['health_facility_name'],
          '#isDisabled': true
        },
        efective_from_date: {
          ...prevState['efective_from_date'],
          '#isDisabled': false
        }
      }))
      if(userDetails?.usertype_name==='Facility Level User'){
        setLinkedFacilityData((prevState) => ({
        ...prevState,
        mobiliser_tagged: {
          ...prevState['mobiliser_tagged'],
          '#title': 'Asha/ Mobiliser Tagged'
        },
      }))
      }
      else if(userDetails?.usertype_name==='Field Level User'){
         setLinkedFacilityData((prevState) => ({
        ...prevState,
        mobiliser_tagged: {
          ...prevState['mobiliser_tagged'],
          '#title': 'ANM/ Health Provider Tagged'
        },
      }))

      }
    }
  }, [showEditLinkedFacility])
  useEffect(() => { }, [showMultipleFacilities]);
  const wardIds=linkedFacility?.v_ward_details?.map((wd:any)=>wd?.ward_id)
    const wardNames=linkedFacility?.v_ward_details?.map((wd:any)=>wd?.ward_name)
    const wardCodes=linkedFacility?.v_ward_details?.map((wd:any)=>wd?.ward_code)
    const villageIds=linkedFacility?.v_village_details?.map((vd:any)=>vd?.village_id)
    const villageNames=linkedFacility?.v_village_details?.map((vd:any)=>vd?.village_name)
    const villageCodes=linkedFacility?.v_village_details?.map((vd:any)=>vd?.village_code)
    const gramPanchayatIds=linkedFacility?.v_gram_panchayat_details?.map((gd:any)=>gd?.gram_panchayat_id)
    const gramPanchayatNames=linkedFacility?.v_gram_panchayat_details?.map((gd:any)=>gd?.gram_panchayat_name)
    const gramPanchayatCodes=linkedFacility?.v_gram_panchayat_details?.map((gd:any)=>gd?.gram_panchayat_code)
    const healthProviderIds=linkedFacility?.health_provider_details?.map((hd:any)=>hd?.health_provider_id)
    const healthProviderNames=linkedFacility?.health_provider_details?.map((hd:any)=>hd?.health_provider_f_name + " " + hd?.health_provider_l_name)
    const healthProviderLastName=linkedFacility?.health_provider_details?.map((hd:any)=>hd?.health_provider_l_name)
    const mobiliserIds=linkedFacility?.mobiliser_provider_details?.map((md:any)=>md?.mobiliser_id)
    const mobiliserNames=linkedFacility?.mobiliser_provider_details?.map((md:any)=>md?.mobiliser_f_name + " " + md?.mobiliser_l_name)
    const mobiliserLastName=linkedFacility?.mobiliser_provider_details?.map((md:any)=>md?.mobiliser_l_name)

  useEffect(() => {
    setLinkedFacilityForm((prevState) => ({
      ...prevState,
      hfr_id: {
        ...prevState['hfr_id'],
        value: linkedFacility.hfr_id,
        isError: false,
        message: ''
      },
      health_facility_type: {
        ...prevState['facility_type_name'],
        value: linkedFacility.facility_type_name,
        isError: false,
        id: linkedFacility.facility_type_id,
        code: linkedFacility.facility_type_code,
        message: ''
      },
      health_facility_name: {
        ...prevState['facility_name'],
        value: linkedFacility.facility_name,
        isError: false,
        id: linkedFacility.facility_id,
        code: linkedFacility.facility_code,
        message: ''
      },
      wards_covered: {
        ...prevState['wards_covered'],
        value: userDetails?.urban_rural_name === 'urban' ? wardNames : [],
        id: userDetails?.urban_rural_name === 'urban' ? wardIds : [],
        code: userDetails?.urban_rural_name === 'urban' ? wardCodes :[],
        message: ''
      },
      villages_covered: {
        ...prevState['villages_covered'],
        value: userDetails?.urban_rural_name === 'rural' ?isGrampanchayat?[]:  villageNames:[],
        id: userDetails?.urban_rural_name === 'rural' ? isGrampanchayat?[]: villageIds:[],
        code: userDetails?.urban_rural_name === 'rural' ? isGrampanchayat?[]: villageCodes:[],
      },
      gram_panchayat_covered: {
        ...prevState['gram_panchayat_covered'],
        value: userDetails?.urban_rural_name === 'rural' ? isGrampanchayat?  gramPanchayatNames:[]:[],
        id: userDetails?.urban_rural_name === 'rural' ? isGrampanchayat? gramPanchayatIds:[]:[],
        code: userDetails?.urban_rural_name === 'rural' ? gramPanchayatCodes:[],
      },
      mobiliser_tagged: {
        ...prevState['mobiliser_tagged'],
        value: userDetails?.usertype_name === 'Facility Level User' ? mobiliserNames : userDetails?.usertype_name === 'Field Level User' ? healthProviderNames:[],
        isError: false,
        id: userDetails?.usertype_name === 'Facility Level User' ? mobiliserIds : userDetails?.usertype_name === 'Field Level User' ? healthProviderIds:[],
        message: ''
      },
      effective_from_date: {
        ...prevState['effective_from_dt'],
        value: dayjs(linkedFacility.effective_from_dt),
        isError: false,
      },
      remarks: {
        ...prevState['remarks'],
        isError: false,
        value: linkedFacility.remarks,
      }
    }));
    if (linkedFacility.facility_id && showEditLinkedFacility) {
      fetchDropDownData();
    }
  }, [linkedFacility])

  const fetchData = async () => {
    const facilityData = await getData<any[]>(`${endpoints.getLinkedFacilitiesByUserId(id)}`);
    const facilityDataWithAction = constructActionData(facilityData?.data[0]);
    setFacilityDetails(facilityDataWithAction);
    
    let count = 0;
    for (let i = 0; i < facilityDataWithAction.length; i++) {
      
      if (facilityDataWithAction[i].is_linked) {
        ++count;
      }
    }
    setLinkedFacilitiesCount(count);
    
    const userDetail = await getData<any[]>(`${endpoints.getUserById}/${id}`);
    setUserDetails(userDetail.data[0]);
    const userDetails = userDetail.data[0];
    let isUsingGramPanchayat: boolean = false;
    isUsingGramPanchayat=await isUsingGramPanchayatUtils(userDetails?.state_code)
    setIsGrampanchayat(isUsingGramPanchayat);
    if(userDetails?.usertype_name==='Facility Level User'){
      setIsFacilityOrFieldUser('Facility Level User');
      setHealthProviderData((prevState) => ({
        ...prevState,
        mobiliser_tagged: {
          ...prevState['mobiliser_tagged'],
          '#title': 'Asha/ Mobiliser Tagged',
        },
      }));
      setCoverageShiftTransferData((prevState) => ({
        ...prevState,
        mobiliser_tagged: {
          ...prevState['mobiliser_tagged'],
          '#title': 'Asha/ Mobiliser Tagged',
        },
      }))
    }
    else if(userDetails?.usertype_name==='Field Level User'){
      setIsFacilityOrFieldUser('Field Level User');
      setHealthProviderData((prevState) => ({
        ...prevState,
        mobiliser_tagged: {
          ...prevState['mobiliser_tagged'],
          '#title': 'ANM/ Health Provider Tagged',
        },
      }));
      setCoverageShiftTransferData((prevState) => ({
        ...prevState,
        mobiliser_tagged: {
          ...prevState['mobiliser_tagged'],
          '#title': 'ANM/ Health Provider Tagged',
        },
      }))
    }
    else{
      setIsFacilityOrFieldUser('');
    }
  }

  useEffect(() => {
    fetchData();
    if (navigateShiftTransfer) {
      setShowShiftTransfer(true);
      setIsShowShiftTransferEnabled(true);
      fetchShiftTransferData();
      setShiftTransferData((prevState) => ({
        ...prevState,
        efective_from_date: {
          '#type': 'date',
          '#title': 'Effective From Date',
          '#webform_key': 'effective_from_date',
          '#required': true,
          '#isDisabled': true,
          '#maxDate': dayjs(new Date()).format('YYYY-MM-DD'),
          '#minDate': dayjs().startOf('month').format('YYYY-MM-DD')
        }
      }))
      setShiftTransferForm((prevState: any) => ({
        ...prevState,
        effective_from_date: {
          ...prevState['effective_from_date'],
          value: dayjs(unlinkPayload.effectiveFromDate),
          isError: false,
          message: '',
          id: '',
        },
        state: {
          ...prevState['state'],
          value: `${userDetails?.state_name}-${userDetails?.state_code}`,
        }
      }))
    }
    if (navigateLinkPayload) {
      setIsLinkingMultipleFacilities(true)
      setIsShowLinkedFacilityEnabled(true)
      setLinkedFacilityData((prevState) => ({
        ...prevState,
        efective_from_date: {
          '#type': 'date',
          '#title': 'Effective From Date',
          '#webform_key': 'effective_from_date',
          '#required': true,
          '#isDisabled': true,
          '#dateMinimum': 'true',
          '#maxDate': dayjs(new Date()).format('YYYY-MM-DD'),
          '#minDate': ''
        },
      }))
      setLinkedFacilityForm((prevState: any) => ({
        ...prevState,
        ['effective_from_date']: {
          ...prevState['effective_from_date'],
          value: dayjs(unlinkPayload.effectiveFromDate),
          isError: false,
          message: '',
          id: id
        },
      }));

      setHealthProviderData((prevState) => ({
        ...prevState,
        effective_from_date: {
          ...prevState['effective_from_date'],
          '#isDisabled': true
        }
      }))

      setHealthProviderForm((prevState: any) => ({
        ...prevState,
        ['effective_from_date']: {
          ...prevState['effective_from_date'],
          value: dayjs(unlinkPayload.effectiveFromDate),
          isError: false,
          message: '',
          id: id
        },
      }));
    }
    dispatch(updateForm("navigateLinkPayload", false))
    dispatch(updateForm("navigateShiftTransfer", false))
    dispatch(updateForm("isFacilityDeleted", false))
    dispatch(updateForm("isUserActive", true));
    dispatch(updateForm("isLinkUnLinkButtonCLicked", false))

  }, [isLinkUnLinkButtonCLicked, isSubmitButtonClicked, isFacilityDeleted, isUserActive,
    navigateLinkPayload, navigateShiftTransfer])
  useEffect(() => {
    dispatch(updateForm("linkedFacilityCount", linkedFacilitiesCount));
  }, [linkedFacilitiesCount])

  useEffect(() => {
      workflowExistsForApproval();   
  }, [id])

  const fetchDropDownData = async () => {
    if (userDetails?.urban_rural_name === "urban") {
      const data = await getData<any[]>(`${endpoints.getWardByFacilityId(linkedFacility.facility_id)}`);
      setLinkedFacilityData((prevState) => ({
        ...prevState,
        wards_covered: {
          ...prevState['wards_covered'],
          '#options': data.data.map((key: any) => ({
            value: key.ward_name,
            label: key.ward_name,
            id: key.ward_id,
            code: key.ward_code
          }))
        },
      }))

    }
    else {
      if(isGrampanchayat){
        const gramPanchayat = await getData<any[]>(`${endpoints.getGramPanchayatCoverageByFacilityId(linkedFacility.facility_id)}`);
        const gramPanchayatOptions = gramPanchayat.data.map((option1: any) => ({
          value: option1.gram_panchayat_name,
          label: option1.gram_panchayat_name,
          id: option1.gram_panchayat_id,
          code: option1.gram_panchayat_code,
        }));
        setLinkedFacilityData((prevState) => ({
          ...prevState,
          gram_panchayat_covered: {
            ...prevState['gram_panchayat_covered'],
            '#options': gramPanchayatOptions
          },
        }))
      }
      else{
        const data = await getData<any[]>(`${endpoints.getVillageByFacilityId(linkedFacility.facility_id)}`);
        setLinkedFacilityData((prevState) => ({
          ...prevState,
          villages_covered: {
            ...prevState['villages_covered'],
            '#options': data.data.map((key: any) => ({
              value: key.village_name,
              label: key.village_name,
              id: key.village_id,
              code: key.village_code
            }))
          },
        }))
      }
    }
    if(userDetails?.usertype_name === 'Facility Level User'){
      const data = await getData<any[]>(`${endpoints.getASHAMobiliserTagged(linkedFacility.facility_id)}`);
      setLinkedFacilityData((prevState) => ({
        ...prevState,
        mobiliser_tagged: {
          ...prevState['mobiliser_tagged'],
          '#options': data?.data?.map((key: any) => ({
            value: `${key.f_name} ${key.l_name}`,
            label: `${key.f_name} ${key.l_name}`,
            id: key.user_id,
            code: key.user_code
          }))
        },
      }))
    }
    else if(userDetails?.usertype_name === 'Field Level User'){
      const data = await getData<any[]>(`${endpoints.getHealthProviderTagged(linkedFacility.facility_id)}`);
      setLinkedFacilityData((prevState) => ({
        ...prevState,
        mobiliser_tagged: {
          ...prevState['mobiliser_tagged'],
          '#options': data?.data?.map((key: any) => ({
            value: `${key.f_name} ${key.l_name}`,
            label: `${key.f_name} ${key.l_name}`,
            id: key.user_id,
            code: key.user_code
          }))
        },
      }))

    }
  }
  const parentUserId = localStorage.getItem('userId');
  // const deletedVillageIds: any[] = [];
  // const deletedWardIds: any[] = []
  // const deletedGramPanchayatIds: any[] = []
  // const deletedHealthProviderIds: any[] = []
  // const deletedMobilizerIds: any[] = []
  
  const handleEdit = async () => {
    try{
    // if (userDetails?.urban_rural_name === 'rural') {
    //   if(isGrampanchayat){
    //     const gramPanchayatIds=linkedFacility?.v_gram_panchayat_details?.map((gd:any)=>gd?.gram_panchayat_id)
    //     const gramPanchayatMappedInitially = gramPanchayatIds?.length>0 ? gramPanchayatIds : []
    //     const gramPanchayatMappedFinally = linkedFacilityForm.gram_panchayat_covered.id?.length !== 0 ? linkedFacilityForm.gram_panchayat_covered.id : [];
    //     for (let i = 0; i < gramPanchayatMappedInitially.length; i++) {
    //       if (!gramPanchayatMappedFinally.includes(gramPanchayatMappedInitially[i])) {
    //         deletedGramPanchayatIds.push(gramPanchayatMappedInitially[i])
    //       }
    //     }
    //   }
    //   else{
    //     const villageIds=linkedFacility?.v_village_details?.map((vd:any)=>vd?.village_id)
    //     const villagesMappedInitially = villageIds?.length>0 ? villageIds : []
    //     const villagesMappedFinally = linkedFacilityForm?.villages_covered?.id?.length !== 0 ? linkedFacilityForm.villages_covered.id : [];
    //     for (let i = 0; i < villagesMappedInitially?.length; i++) {
    //       if (villagesMappedFinally && !villagesMappedFinally?.includes(villagesMappedInitially[i])) {
    //         deletedVillageIds?.push(villagesMappedInitially[i])
    //       }
    //     }
    // }
    // }
    // else if (userDetails?.urban_rural_name === 'urban') {
    //   const wardIds=linkedFacility?.v_ward_details?.map((wd:any)=>wd?.ward_id)
    //   const wardsMappedInitially = wardIds?.length>0 ? wardIds : []
    //   const wardsMappedFinally = linkedFacilityForm.wards_covered.id?.length !== '' ? linkedFacilityForm.wards_covered.id : [];
    //   for (let i = 0; i < wardsMappedInitially.length; i++) {
    //     if (!wardsMappedFinally.includes(wardsMappedInitially[i])) {
    //       deletedWardIds.push(wardsMappedInitially[i])
    //     }
    //   }
    // }

    // if(userDetails?.usertype_name === 'Facility Level User'){
    //   const mobiliserIds = linkedFacility?.mobiliser_provider_details?.map((md: any) => md?.mobiliser_id)
    //   const linkedMobiliserIdsInitially = mobiliserIds?.length > 0 ? mobiliserIds : [];
    //   const linkedMobiliserIdsFinally = linkedFacilityForm.mobiliser_tagged.id === '' ? [] : linkedFacilityForm.mobiliser_tagged.id;
    //   for (let i = 0; i < linkedMobiliserIdsInitially?.length; i++) {
    //     if (!linkedMobiliserIdsFinally.includes(linkedMobiliserIdsInitially[i])) {
    //       deletedMobilizerIds.push(linkedMobiliserIdsInitially[i])
    //     }
    //   }
    // }
    // else if(userDetails?.usertype_name === 'Field Level User'){
    //   const healthProviderIds = linkedFacility?.health_provider_details?.map((hd: any) => hd?.health_provider_id)
    //   const linkedHealthProviderIdsInitially = healthProviderIds?.length > 0 ? healthProviderIds : [];
    //   const linkedHealthProviderIdsFinally = linkedFacilityForm.mobiliser_tagged.id === '' ? [] : linkedFacilityForm.mobiliser_tagged.id;
    //   for (let i = 0; i < linkedHealthProviderIdsInitially?.length; i++) {
    //     if (!linkedHealthProviderIdsFinally.includes(linkedHealthProviderIdsInitially[i])) {
    //       deletedHealthProviderIds.push(linkedHealthProviderIdsInitially[i])
    //     }
    //   }
    // }
    const data = {
      userfacilityId: linkedFacilityId,
      linkedHealthProviderIds: userDetails?.usertype_name==='Field Level User' && linkedFacilityForm.mobiliser_tagged?.id?.length> 0 ? linkedFacilityForm?.mobiliser_tagged?.id ? linkedFacilityForm?.mobiliser_tagged?.id : [] : [],
      linkedMobilizerIds: userDetails?.usertype_name==='Facility Level User' && linkedFacilityForm.mobiliser_tagged?.id?.length> 0 ? linkedFacilityForm?.mobiliser_tagged?.id ? linkedFacilityForm?.mobiliser_tagged?.id : [] : [],
      linkedVillageIds: userDetails?.urban_rural_name === 'rural' ? (isGrampanchayat?[]: (
       linkedFacilityForm?.villages_covered?.id?.length > 0 ?
       linkedFacilityForm?.villages_covered?.id : [])) : [],
      linkedWardIds:
        userDetails?.urban_rural_name === 'urban' ? (( linkedFacilityForm.wards_covered.id?.length > 0) ?
          linkedFacilityForm.wards_covered.id : []) :
          [],
      linkedGramPranchayatIds:userDetails?.urban_rural_name === 'rural'?(isGrampanchayat?(linkedFacilityForm.gram_panchayat_covered?.id?.length > 0 ? linkedFacilityForm?.gram_panchayat_covered.id:[]):[]):[],
      effectiveFromDate: new Date(dayjs(linkedFacilityForm.effective_from_date.value).format('YYYY-MM-DD')).toISOString().split('T')[0],
      remarks: linkedFacilityForm.remarks.value,
      parentUserId: parentUserId
    }

    try {
      const response = await putDataJSON<any[]>(`${endpoints.updateLinkFacilityForUser}`, data);
      if (response) {
        setShowEditLinkedFacility(false);
        //dispatch(updateForm("isEditButtonCLicked", false))
        if (isSubmitButtonClicked) {
          setIsSubmitButtonCLicked(false);
        }
        else {
          setIsSubmitButtonCLicked(true)
        }
        toast.success("Records have been successfully corrected & saved", {
          position: "top-center"
        });
      }
    }
    catch(error:any){
      errorLogger(error?.response?.data||error?.response||error)
    }
  }
  catch(error:any){
    errorLogger(error?.response?.data||error?.response||error)
  }
  }
  const handleLinkMultipleFacilities = () => {
    if(isGrampanchayat){
      setHealthProviderData((prevState) => ({
        ...prevState,
        gram_panchayat_covered: {
          ...prevState['gram_panchayat_covered'],
          '#isVisible':true
        },
      }))
    }
    else{
      setHealthProviderData((prevState) => ({
        ...prevState,
        villages_covered: {
          ...prevState['villages_covered'],
          '#isVisible':true
        },
      }))
    }
    if(userDetails?.urban_rural_name === 'rural'){
      if(isGrampanchayat){
        setHealthProviderData((prevState) => ({
          ...prevState,
          gram_panchayat_covered: {
            ...prevState['gram_panchayat_covered'],
            '#isDisabled': false,
          },
        }))
      }
      else{
        setHealthProviderData((prevState) => ({
          ...prevState,
          villages_covered: {
            ...prevState['villages_covered'],
            '#isDisabled': false,
          },
        }))
      }
     
    }
    else{
      setHealthProviderData((prevState) => ({
        ...prevState,
        wards_covered: {
          ...prevState['wards_covered'],
          '#isDisabled': false,
        },
      }))
    }
    setIsLinkingMultipleFacilities(true)
    setHealthProviderForm((prevState) => ({
      ...prevState,
      hfr_id: {
        ...prevState['hfr_id'],
        value: '',
        isError: false,
        message: ''
      },
      health_facility_type: {
        ...prevState['health_facility_type'],
        value: '',
        isError: false,
        id: '',
        code: 0,
        message: ''
      },
      health_facility_name: {
        ...prevState['health_facility_name'],
        value: '',
        isError: false,
        id: '',
        code: 0,
        message: ''
      },
      wards_covered: {
        isError: false,
        message: '',
        isDisable: false,
        value: [],
        id: [],
        code: undefined
      },
      villages_covered: {
        isError: false,
        message: '',
        isDisable: false,
        value: [],
        id: [],
        code: undefined
      },
      gram_panchayat_covered: {
        isError: false,
        message: '',
        isDisable: false,
        value: [],
        id: [],
        code: undefined
      },
      mobiliser_tagged: {
        ...prevState['mobiliser_tagged'],
        value: '',
        isError: false,
        id: '',
        code: 0,
        message: ''
      },
      effective_from_date: {
        ...prevState['effective_from_dt'],
        value: "",
        isError: false,
      }
    }))
    setHealthProviderData((prevState) => ({
      ...prevState,
      hfr_id: {
        ...prevState['hfr_id'],
        '#isDisabled': false
      },
      health_facility_type: {
        ...prevState['health_facility_type'],
        '#isDisabled': false
      },
      health_facility_name: {
        ...prevState['health_facility_name'],
        '#isDisabled': false
      },
      effective_from_date: {
        ...prevState['effective_from_date'],
        '#isDisabled': false
      }
    }))
  }


  const handleCancel = () => {
    setIsLinkingMultipleFacilities(false);
    setShowShiftTransfer(false)
    setHealthProviderForm(healthProviderObj);
    setShiftTransferForm(shiftTransferObj);
    setCoverageShiftTransferForm(coverageShiftTransferObj);
    fetchData();
  }

  const handleSaveLinkMultiFacility = async () => {
    try {
      let checkError: any = false;
      if (!healthProviderForm.hfr_id.value) {
        setHealthProviderForm((prevState: any) => ({
          ...prevState,
          hfr_id: {
            ...prevState.hfr_id,
            isError: true,
            message: 'HFR ID cannot be blank. Enter valid HFR ID.',
          },
        }));
        checkError = true;
      }
      if (!healthProviderForm.health_facility_type.value) {
        setHealthProviderForm((prevState: any) => ({
          ...prevState,
          health_facility_type: {
            ...prevState.health_facility_type,
            isError: true,
            message: 'Health Facility Type cannot be kept blank. Select an applicable option from Dropdown.',
          },
        }));
        checkError = true;
      }
      if (!healthProviderForm.health_facility_name.value) {
        setHealthProviderForm((prevState: any) => ({
          ...prevState,
          health_facility_name: {
            ...prevState.health_facility_name,
            isError: true,
            message: 'Health Facility Name cannot be kept blank. Select an applicable option from Dropdown.',
          },
        }));
        checkError = true;
      }

      if (!healthProviderForm.effective_from_date.value) {
        setHealthProviderForm((prevState: any) => ({
          ...prevState,
          effective_from_date: {
            ...prevState.effective_from_date,
            isError: true,
            message: 'Effective From Date cannot be kept blank. Enter Effective From Date.',
          },
        }));
        checkError = true;
      }


      if (!checkError) {
        const facilityId = facilityDetails1?.find((item: any) => item.hfr_id === healthProviderForm.hfr_id.value)?.facilit_id;
        if (!facilityId) {
          setHealthProviderForm((prevState: any) => ({
            ...prevState,
            hfr_id: {
              ...prevState.hfr_id,
              isError: true,
              message: 'HFR ID cannot be blank. Enter valid HFR ID.',
            },
          }));
          return;
        }
        // const villageOrWardsIds: any[] = [];
        // villageAndWardDetails?.forEach((key: any) => {
        //   if (healthProviderForm.villagesAndwards.value.includes(key.value)) {
        //     villageOrWardsIds.push(key.id);
        //   }
        // })
        const ashaMobilizerTaggedIds: any[] = [];
        mobiliserTaggedDetails?.forEach((key: any) => {
          if (healthProviderForm.mobiliser_tagged.value.includes(key.value)) {
            ashaMobilizerTaggedIds.push(key.id);
          }
        })
        const linkPayload = {
          userId: id,
          facilityId: facilityId,
          healthProviderId: userDetails?.usertype_name==='Field Level User' ? ashaMobilizerTaggedIds ? ashaMobilizerTaggedIds : [] : [],
          mobilzerId: userDetails?.usertype_name==='Facility Level User' ? ashaMobilizerTaggedIds ? ashaMobilizerTaggedIds : [] : [],
          wardId: userDetails?.urban_rural_name === 'urban' ? healthProviderForm.wards_covered.id : [],
          villageId: userDetails?.urban_rural_name === 'rural' ? isGrampanchayat?[]: healthProviderForm.villages_covered.id : [],
          gramPranchayatIds: userDetails?.urban_rural_name === 'rural' ? isGrampanchayat? healthProviderForm.gram_panchayat_covered.id:[] : [],
          effectiveFromDate: new Date(dayjs(healthProviderForm.effective_from_date.value).format('YYYY-MM-DD')).toISOString().split('T')[0],
          remarks: healthProviderForm.remarks.value || null
        }

        const submitResponse = await axios.post(endpoints.linkFacilityForUser, linkPayload, Auth.loggedInWithJSON());
        
        if (isShowLinkedFacilityEnabled) {
        const response = await postDataJSON(`${endpoints.unLinkFacilityForUser}`, unlinkPayload);
          setIsShowLinkedFacilityEnabled(false);
        }
        handleCancel();
        if (isSubmitButtonClicked) {
          setIsSubmitButtonCLicked(false);
        }
        else {
          setIsSubmitButtonCLicked(true)
        }
        // fetchData()
        if (submitResponse.status === 200) {
          setHealthProviderData((prevState) => ({
            ...prevState,
            mobiliser_tagged: {
              ...prevState.mobiliser_tagged,
              '#options': [],
            },
          }));
          setMobiliserTaggedDetails([]);
          toast.success("Facility have been linked successfully", {
            position: "top-center"
          });
        }
      }
    }
    catch(error:any){
      errorLogger(error?.response?.data||error?.response||error)
    }
  };
  const handleSaveShiftTransfer = async () => {
    try {
      let checkError: any = false
      if (!shiftTransferForm.state.value) {
        setShiftTransferForm((prevState: any) => ({
          ...prevState,
          state: {
            ...prevState.state,
            isError: true,
            message: 'State cannot be kept blank. Select user state from dropdown.',
          },
        }));
        checkError = true;
      }
      if (!shiftTransferForm.district.value) {
        setShiftTransferForm((prevState: any) => ({
          ...prevState,
          district: {
            ...prevState.district,
            isError: true,
            message: 'District cannot be kept blank. Select user District from dropdown.',
          },
        }));
        checkError = true;
      }
      if (!shiftTransferForm.effective_from_date.value) {
        setShiftTransferForm((prevState: any) => ({
          ...prevState,
          effective_from_date: {
            ...prevState.effective_from_date,
            isError: true,
            message: 'Effective From Date cannot be kept blank. Enter Effective From Date.',
          },
        }));
        checkError = true;
      }
      if (!shiftTransferForm.rural_urban.value) {
        setShiftTransferForm((prevState: any) => ({
          ...prevState,
          rural_urban: {
            ...prevState.rural_urban,
            isError: true,
            message: 'Select Rural or Urban from the dropdown.',
          },
        }));
        checkError = true;
      }
      if (!shiftTransferData.ulb['#isDisabled'] && !shiftTransferForm.ulb.value) {
        setShiftTransferForm((prevState: any) => ({
          ...prevState,
          ulb: {
            ...prevState.ulb,
            isError: true,
            message: 'Select Ulb from the dropdown.',
          },
        }));
        checkError = true;
      }
      if (!shiftTransferData.ward['#isDisabled'] && !shiftTransferForm.ward.value) {
        setShiftTransferForm((prevState: any) => ({
          ...prevState,
          ward: {
            ...prevState.ward,
            isError: true,
            message: 'Select Ward from the dropdown.',
          },
        }));
        checkError = true;
      }
      if (!shiftTransferData.block['#isDisabled'] && !shiftTransferForm.block.value) {
        setShiftTransferForm((prevState: any) => ({
          ...prevState,
          block: {
            ...prevState.block,
            isError: true,
            message: 'Select Block from the dropdown.',
          },
        }));
        checkError = true;
      }
      if (!shiftTransferData.village['#isDisabled'] && shiftTransferData.village['#isVisible'] && !shiftTransferForm.village.value) {
        setShiftTransferForm((prevState: any) => ({
          ...prevState,
          village: {
            ...prevState.village,
            isError: true,
            message: 'Select Village from the dropdown.',
          },
        }));
        checkError = true;
      }
      if (!shiftTransferData.gram_panchayat['#isDisabled'] && shiftTransferData.gram_panchayat['#isVisible'] && !shiftTransferForm.gram_panchayat.value) {
        setShiftTransferForm((prevState: any) => ({
          ...prevState,
          gram_panchayat: {
            ...prevState.gram_panchayat,
            isError: true,
            message: 'Select Gram Panchayat from the dropdown.',
          },
        }));
        checkError = true;
      }
      if (!coverageShiftTransferForm.hfr_id.value) {
        setCoverageShiftTransferForm((prevState: any) => ({
          ...prevState,
          hfr_id: {
            ...prevState.hfr_id,
            isError: true,
            message: 'HFR ID cannot be blank. Enter valid HFR ID.',
          }
        }));
        checkError = true;
      }
      if (!coverageShiftTransferForm.health_facility_type.value) {
        setCoverageShiftTransferForm((prevState: any) => ({
          ...prevState,
          health_facility_type: {
            ...prevState.health_facility_type,
            isError: true,
            message: 'Health Facility Type cannot be kept blank. Select an applicable option from Dropdown.',
          }
        }));
        checkError = true;
      }
      if (!coverageShiftTransferForm.health_facility_name.value) {
        setCoverageShiftTransferForm((prevState: any) => ({
          ...prevState,
          health_facility_name: {
            ...prevState.health_facility_name,
            isError: true,
            message: 'Health Facility Name cannot be kept blank. Select an applicable option from Dropdown.',
          }
        }));
        checkError = true;
      }

      if (!checkError) {
        const facilityId = facilityDetails1?.find((item: any) => item.hfr_id === coverageShiftTransferForm.hfr_id.value)?.facilit_id;
        if (!facilityId) {
          setCoverageShiftTransferForm((prevState: any) => ({
            ...prevState,
            hfr_id: {
              ...prevState.hfr_id,
              isError: true,
              message: 'HFR ID cannot be blank. Enter valid HFR ID.',
            },
          }));
          return;
        }
        // const villageOrWardsIds: any[] = [];
        // villageAndWardDetails?.forEach((key: any) => {
        //   if (coverageShiftTransferForm.villagesAndwards.value.includes(key.value)) {
        //     villageOrWardsIds.push(key.id);
        //   }
        // })

        let urbanRuralId = '';
        urbanRuralId = shiftTransferForm.rural_urban.value === 'Urban' ? 'faf5bda0-4c2b-45ac-afd2-33e97d985d3e' : '4485c41d-2142-43a2-b6d2-735b58caef09';
        const intraDistId = shiftTransferForm.district.value === userDetails?.district_name + '-' + userDetails?.district_code;
        const ashaMobilizerTaggedIds: any[] = [];
        mobiliserTaggedDetails?.forEach((key: any) => {
          if (coverageShiftTransferForm.mobiliser_tagged.value.includes(key.value)) {
            ashaMobilizerTaggedIds.push(key.id);
          }
        })

        const shiftPayload = {
          userId: id,
          facilityId: facilityId || null,
          healthProviderIds: userDetails?.usertype_name==='Field Level User' ? ashaMobilizerTaggedIds ? ashaMobilizerTaggedIds : [] : [],
          mobiliserIds: userDetails?.usertype_name==='Facility Level User' ? ashaMobilizerTaggedIds ? ashaMobilizerTaggedIds : [] : [],
          effectiveFromDate: new Date(dayjs(shiftTransferForm.effective_from_date.value).format('YYYY-MM-DD')).toISOString().split('T')[0],
          stId: userDetails.state_id || null,
          stCode: userDetails.state_code || null,
          distCode: shiftTransferForm.district.code || null,
          p_subDistId: shiftTransferForm.sub_district.id || null,
          ulbId: shiftTransferForm.ulb.id || null,
          blockId: shiftTransferForm.block.id || null,
          healthBlockId: shiftTransferForm.health_block.id || null,
          subDivisionId: shiftTransferForm.sub_division.id || null,
          wardId: shiftTransferForm.ward.id || null,
          villageId: isGrampanchayat?null:shiftTransferForm.village.id || null,
          grampanchayatId: isGrampanchayat?shiftTransferForm.gram_panchayat.id || null:null,
          urbanRuralId: urbanRuralId || null,
          parentUserId: parentUserId,
          linkedWardIds:shiftTransferForm.rural_urban.value?.toLowerCase() === 'urban'?coverageShiftTransferForm.wards_covered.id:[],// userDetails?.urban_rural_name === 'urban' ? villageOrWardsIds : [],
          linkedVillageIds:shiftTransferForm.rural_urban.value.toLowerCase() === 'rural' ? isGrampanchayat? [] :coverageShiftTransferForm.villages_covered.id : [],
          linkedGramPranchayatIds: shiftTransferForm.rural_urban.value.toLowerCase() === 'rural' ?isGrampanchayat? coverageShiftTransferForm.gram_panchayat_covered.id:[] : [],
          intraDistId: intraDistId,
          distId: shiftTransferForm.district.id || null
        }
        const submitResponse = await axios.post(endpoints.createShiftTransfer, shiftPayload, Auth.loggedInWithJSON());
        handleCancel();
        fetchData();
        if (submitResponse.status === 200) {
          toast.success((LogedinUserDetails && LogedinUserDetails?.usertype_name === USER_TYPES.DISTRICT_LEVEL_USER && (roleData == roleType.both || roleData == roleType.only_administrator)) ? "Request sent for Approval" : "Facility have been successfully Shifted/ Tranferred", {
            position: "top-center"
          });
          await workflowExistsForApproval();
        }
      }


    } catch(error:any){
      /*if block will be triggered when DB side we get this error SequelizeDatabaseError: An error occurred while transfering user: new row for relation \"user_facility_tagged\" violates check constraint \"check_effective_dates\"*/ 
      if(error?.response?.status===500 && error?.response?.data?.messages[0]?.stackTraces?.includes(`check_effective_dates`) && error?.response?.data?.messages[0]?.stackTraces?.includes("user_facility_tagged")){
        toast.error("Cannot Shift/Transfer Facility on same date of Linking the Facility", {
          position: "top-center"
        });
        errorLogger(error?.response?.data||error?.response||error)
      }
      else if(error?.response?.status===500 && shiftTransferForm.district.value === userDetails?.district_name + '-' + userDetails?.district_code){
        toast.error("User cannot be transferred to the same district", {
          position: "top-center"
        });
        errorLogger(error?.response?.data||error?.response||error)
      }
      else{
        toast.error("Error occured while Shifting / Transfering Facility", {
          position: "top-center"
        });
       errorLogger(error?.response?.data||error?.response||error)
      }
    }
  }

  useEffect(() => {

    const fetchApiData = async () => {
      if (!userDetails?.state_id) {
        return;
      }
      try {
        const {facility_hfr_options,facility_name_options} = await fetchAndReturnHFRIdTypeAndName(userDetails?.district_id,"Linked Multiple Facility", true);
       const facility_typeResponse = await axios.get(endpoints.getFacilityType, Auth.loggedIn());
       const facility_type_options = facility_typeResponse.data.data.map((key: any) => ({
         value: key.facility_type,
         label: key.facility_type,
         id: key.facility_type_id
       }));

       setHealthProviderData((create_facilitydetails: { health_facility_name: any, hfr_id: any,health_facility_type: any;}) => ({
        ...create_facilitydetails,
        health_facility_name: {
          ...create_facilitydetails.health_facility_name,
          '#options': facility_name_options,
        },
        hfr_id: {
          ...create_facilitydetails.hfr_id,
          '#options': facility_hfr_options,
        },
        health_facility_type: {
          ...create_facilitydetails.health_facility_type,
          '#options': facility_type_options,
        },
      }));
      setCoverageShiftTransferData((create_facilitydetails: { health_facility_name: any; hfr_id: any, health_facility_type: any }) => ({
        ...create_facilitydetails,
        health_facility_type: {
          ...create_facilitydetails.health_facility_type,
          '#options': facility_type_options,
        },
      }));
    }
      catch(error:any){
        errorLogger(error?.response?.data||error?.response||error)
      }
    }

    fetchApiData();

  }, [userDetails]);


  useEffect(() => {
    if (shiftTransferRuralUrban === "Rural") {
      setShiftTransferData((role_details: any) => ({
        ...role_details,
        ulb: {
          ...role_details?.ulb,
          '#isDisabled': true,
          '#required': false,
        },
        ward: {
          ...role_details?.ward,
          '#isDisabled': true,
          '#required': false,
        },
        village: {
          ...role_details?.village,
          '#isDisabled': false,
          '#required': true,
        },
        gram_panchayat: {
          ...role_details?.gram_panchayat,
          '#isDisabled': false,
          '#required': true,
        },
        block: {
          ...role_details?.block,
          '#isDisabled': false,
          '#required': true,
        },

      }))
      setCoverageShiftTransferData((coverage_details: {wards_covered:any; villages_covered: any;gram_panchayat_covered:any }) => ({
        ...coverage_details,
        wards_covered: {
          ...coverage_details?.wards_covered,
          '#isDisabled': true,
        },
        villages_covered: {
          ...coverage_details?.villages_covered,
          '#isDisabled': false,
        },
        gram_panchayat_covered: {
          ...coverage_details?.gram_panchayat_covered,
          '#isDisabled': false,
        },
      }));
    }
    else if (shiftTransferRuralUrban === "Urban") {
      setShiftTransferData((shift_transfer: any) => ({
        ...shift_transfer,
        ulb: {
          ...shift_transfer?.ulb,
          '#isDisabled': false,
          '#required': true,
        },
        ward: {
          ...shift_transfer?.ward,
          '#isDisabled': false,
          '#required': true,
        },
        village: {
          ...shift_transfer?.village,
          '#isDisabled': true,
          '#required': false,
        },
        gram_panchayat: {
          ...shift_transfer?.gram_panchayat,
          '#isDisabled': true,
          '#required': false,
        },
        block: {
          ...shift_transfer?.block,
          '#isDisabled': true,
          '#required': false,
        },

      }))
      setCoverageShiftTransferData((coverage_details: {wards_covered:any; villages_covered: any;gram_panchayat_covered:any }) => ({
        ...coverage_details,
        wards_covered: {
          ...coverage_details?.wards_covered,
          '#isDisabled': false,
        },
        villages_covered: {
          ...coverage_details?.villages_covered,
          '#isDisabled': true,
        },
        gram_panchayat_covered: {
          ...coverage_details?.gram_panchayat_covered,
          '#isDisabled': true,
        },
      }));
    } else if (shiftTransferRuralUrban === '' || shiftTransferRuralUrban === null || shiftTransferRuralUrban === undefined) {
      setShiftTransferData((shift_transfer: any) => ({
        ...shift_transfer,
        ulb: {
          ...shift_transfer?.ulb,
          '#isDisabled': true,
          '#required': false,
        },
        ward: {
          ...shift_transfer?.ward,
          '#isDisabled': true,
          '#required': false,
        },
        village: {
          ...shift_transfer?.village,
          '#isDisabled': true,
          '#required': false,
        },
        gram_panchayat: {
          ...shift_transfer?.gram_panchayat,
          '#isDisabled': true,
          '#required': false,
        },
        block: {
          ...shift_transfer?.block,
          '#isDisabled': true,
          '#required': false,
        },
      }))
      setCoverageShiftTransferData((coverage_details: {wards_covered:any; villages_covered: any;gram_panchayat_covered:any }) => ({
        ...coverage_details,
        wards_covered: {
          ...coverage_details?.wards_covered,
          '#isDisabled': true,
        },
        villages_covered: {
          ...coverage_details?.villages_covered,
          '#isDisabled': true,
        },
        gram_panchayat_covered: {
          ...coverage_details?.gram_panchayat_covered,
          '#isDisabled': true,
        },
      }));
    }

  }, [shiftTransferRuralUrban])

  const fetchVillageWardAndAsha = async (facility_id: any) => {
    try {

      let wardOrVillageDetails: any = [];
      if (userDetails?.urban_rural_name === 'urban') {
        wardOrVillageDetails = await axios.get(`${endpoints.getWardByFacilityId(facility_id)}`, Auth.loggedIn());
        const ward_village_options = wardOrVillageDetails.data.data.map((key: any) => ({
          value: key.ward_name ,
          label: key.ward_name ,
          id: key.ward_id ,
        }));
        setHealthProviderData((create_facilitydetails: {  wards_covered: any; }) => ({
          ...create_facilitydetails,
          wards_covered: {
            ...create_facilitydetails.wards_covered,
            '#options': ward_village_options,
          },
        }));
      }
      else {
        if(isGrampanchayat){
          const gramPanchayat = await getData<any[]>(`${endpoints.getGramPanchayatCoverageByFacilityId(facility_id)}`);
          const gramPanchayatOptions = gramPanchayat.data.map((option1: any) => ({
            value: option1.gram_panchayat_name,
            label: option1.gram_panchayat_name,
            id: option1.gram_panchayat_id,
            code: option1.gram_panchayat_code,
          }));
          setHealthProviderData((create_facilitydetails: { gram_panchayat_covered: any; }) => ({
            ...create_facilitydetails,
            gram_panchayat_covered: {
              ...create_facilitydetails.gram_panchayat_covered,
              '#options': gramPanchayatOptions,
            },
          }));
        }
        else{
          wardOrVillageDetails = await axios.get(`${endpoints.getVillageByFacilityId(facility_id)}`, Auth.loggedIn());
          const ward_village_options = wardOrVillageDetails.data.data.map((key: any) => ({
            value: (key.village_name) + "-" + (key.village_code),
            label: ( key.village_name) + "-" + (key.village_code),
            id:  key.village_id,
          }));
         setHealthProviderData((create_facilitydetails: { villages_covered: any; }) => ({
            ...create_facilitydetails,
            villages_covered: {
              ...create_facilitydetails.villages_covered,
              '#options': ward_village_options,
            },
          }));
        }
      }

      if(userDetails.usertype_name === 'Facility Level User'){
        const mobiliserTaggedDetail = await axios.get(`${endpoints.getASHAMobiliserTagged(facility_id)}`, Auth.loggedIn());
      const mobiliserTaggedOptions = mobiliserTaggedDetail.data.data.map((key: any) => ({
        value: key.f_name + " " + key.l_name,
        label: key.f_name + " " + key.l_name,
        id: key.user_id
      }));
      setMobiliserTaggedDetails(mobiliserTaggedOptions);

      setHealthProviderData((create_facilitydetails: { mobiliser_tagged: any, villagesAndwards: any; }) => ({
        ...create_facilitydetails,
        mobiliser_tagged: {
          ...create_facilitydetails.mobiliser_tagged,
          '#options': mobiliserTaggedOptions,
        },
      }));
      }
      else if(userDetails.usertype_name === 'Field Level User'){
        const mobiliserTaggedDetail = await axios.get(`${endpoints.getHealthProviderTagged(facility_id)}`, Auth.loggedIn());
      const mobiliserTaggedOptions = mobiliserTaggedDetail.data.data.map((key: any) => ({
        value: key.f_name + " " + key.l_name,
        label: key.f_name + " " + key.l_name,
        id: key.user_id
      }));
      setMobiliserTaggedDetails(mobiliserTaggedOptions);

      setHealthProviderData((create_facilitydetails: { mobiliser_tagged: any, villagesAndwards: any; }) => ({
        ...create_facilitydetails,
        mobiliser_tagged: {
          ...create_facilitydetails.mobiliser_tagged,
          '#options': mobiliserTaggedOptions,
        },
      }));

      }
    }
    catch(error:any){
      errorLogger(error?.response?.data||error?.response||error)
    }
  }

  const fetchVillageWardAndAshaShiftTransfer = async (facility_id: any) => {
    try {

      let wardOrVillageDetails: any = [];
     // if (userDetails?.urban_rural_name === 'urban') {
      if (shiftTransferForm?.rural_urban?.value.toLowerCase() === 'urban') {
      
        wardOrVillageDetails = await axios.get(`${endpoints.getWardByFacilityId(facility_id)}`, Auth.loggedIn());
        const ward_village_options = wardOrVillageDetails.data.data.map((key: any) => ({
          value: (key.ward_name ) + "-" + (key.ward_code ),
          label: (key.ward_name ) + "-" + (key.ward_code ),
          id: key.ward_id ,
        }));
        //setVillageAndWardDetails(ward_village_options);
        setCoverageShiftTransferData((create_facilitydetails: { wards_covered: any; }) => ({
          ...create_facilitydetails,
          wards_covered: {
            ...create_facilitydetails.wards_covered,
            '#options': ward_village_options,
          },
        }));
      }
      else {
        if(isGrampanchayat){
          const gramPanchayat = await getData<any[]>(`${endpoints.getGramPanchayatCoverageByFacilityId(facility_id)}`);
          const gramPanchayatOptions = gramPanchayat.data.map((option1: any) => ({
            value: option1.gram_panchayat_name,
            label: option1.gram_panchayat_name,
            id: option1.gram_panchayat_id,
            code: option1.gram_panchayat_code,
          }));
          setCoverageShiftTransferData((create_facilitydetails: { gram_panchayat_covered: any; }) => ({
            ...create_facilitydetails,
            gram_panchayat_covered: {
              ...create_facilitydetails.gram_panchayat_covered,
              '#options': gramPanchayatOptions,
            },
          }));
        }
        else{
          wardOrVillageDetails = await axios.get(`${endpoints.getVillageByFacilityId(facility_id)}`, Auth.loggedIn());
          const ward_village_options = wardOrVillageDetails.data.data.map((key: any) => ({
            value: (key.village_name) + "-" + (key.village_code),
            label: ( key.village_name) + "-" + (key.village_code),
            id:  key.village_id,
          }));
         // setVillageAndWardDetails(ward_village_options);
          setCoverageShiftTransferData((create_facilitydetails: { villages_covered: any; }) => ({
            ...create_facilitydetails,
            villages_covered: {
              ...create_facilitydetails.villages_covered,
              '#options': ward_village_options,
            },
          }));
        }
      }
      if(userDetails.usertype_name === 'Facility Level User'){
      const mobiliserTaggedDetail = await axios.get(`${endpoints.getASHAMobiliserTagged(facility_id)}`, Auth.loggedIn());

      const mobiliserTaggedOptions = mobiliserTaggedDetail.data.data.map((key: any) => ({
        value: key.f_name + " " + key.l_name,
        label: key.f_name + " " + key.l_name,
        id: key.user_id
      }));
      setMobiliserTaggedDetails(mobiliserTaggedOptions);
      setCoverageShiftTransferData((create_facilitydetails: { mobiliser_tagged: any }) => ({
        ...create_facilitydetails,
        mobiliser_tagged: {
          ...create_facilitydetails.mobiliser_tagged,
          '#options': mobiliserTaggedOptions,
        },
      }));
      }
      else if(userDetails.usertype_name === 'Field Level User'){
      const mobiliserTaggedDetail = await axios.get(`${endpoints.getHealthProviderTagged(facility_id)}`, Auth.loggedIn());

      const mobiliserTaggedOptions = mobiliserTaggedDetail.data.data.map((key: any) => ({
        value: key.f_name + " " + key.l_name,
        label: key.f_name + " " + key.l_name,
        id: key.user_id
      }));
      setMobiliserTaggedDetails(mobiliserTaggedOptions);
      setCoverageShiftTransferData((create_facilitydetails: { mobiliser_tagged: any }) => ({
        ...create_facilitydetails,
        mobiliser_tagged: {
          ...create_facilitydetails.mobiliser_tagged,
          '#options': mobiliserTaggedOptions,
        },
      }));
      }
    }
    catch(error:any){
      errorLogger(error?.response?.data||error?.response||error)
    }
  }

  const fetchShiftFieldOptionsById = async (selected_id: any, type: string) => {
    try {
      if (type === "district") {
        const sub_districtsResponse = await axios.get(`${endpoints.getSubDistricts(selected_id)}`, Auth.loggedIn());
        setShiftTransferSubDistricts(sub_districtsResponse?.data?.data)
        const sub_districts_options = sub_districtsResponse?.data?.data.map((key: any) => ({
          value: key.sub_district_name + '-' + key.sub_district_code,
          label: key.sub_district_name + '-' + key.sub_district_code,
          id: key.sub_district_id,
        }))
        const blockResponse = await axios.get(`${endpoints.getBlock(selected_id)}`, Auth.loggedIn());
        setShiftTransferBlocks(blockResponse?.data?.data)
        const block_options = blockResponse?.data?.data.map((key: any) => ({
          value: key.block_name + '-' + key.block_code,
          label: key.block_name + '-' + key.block_code,
          id: key.block_id,
        }))
        const health_blockResponse = await axios.get(`${endpoints.getHealthBlock(selected_id)}`, Auth.loggedIn());
        let health_block_options = health_blockResponse?.data?.data.map((key: any) => ({
          value: key.heal_block_name + "-" + key.heal_block_code,
          label: key.heal_block_name + "-" + key.heal_block_code,
          id: key.health_block_id
        }))
        health_block_options = health_block_options.filter((item: any) => item.value);
        const sub_divisionResponse = await axios.get(`${endpoints.getSubDivision(selected_id)}`, Auth.loggedIn());
        const sub_division_options = sub_divisionResponse?.data?.data.map((key: any) => ({
          value: key.sub_division_name + '-' + key.sub_division_code,
          label: key.sub_division_name + '-' + key.sub_division_code,
          id: key.sub_division_id
        }))
        setShiftTransferData((create_facilitydetails: { sub_district: any; block: any; health_block: any; sub_division: any; }) => ({
          ...create_facilitydetails,
          sub_district: {
            ...create_facilitydetails.sub_district,
            '#options': sub_districts_options,
          },
          block: {
            ...create_facilitydetails.block,
            '#options': block_options,
          },
          health_block: {
            ...create_facilitydetails.health_block,
            '#options': health_block_options,
          },
          sub_division: {
            ...create_facilitydetails.sub_division,
            '#options': sub_division_options,
          },
        }))
      } 
      else if (type === "sub_district") {
        if (!isGrampanchayat) {
          const postData = {
            p_state_id: userDetails?.state_id,
            p_dist_id: shiftTransferForm?.district?.id,
            p_sub_dist_ids: [selected_id],
            p_block_ids: shiftTransferForm?.block?.id ? [shiftTransferForm.block.id] : [],
            p_hbsd_ids: [],
          };
          const villagesResponse = await axios.post(`${endpoints.getVillagesByStateDistSubDisBlockId}`, postData, Auth.loggedInWithJSON());
          const village_options = villagesResponse?.data?.data.map((key: any) => ({
            value: key.village_name + "-" + key.village_code,
            label: key.village_name + "-" + key.village_code,
            id: key.village_id
          }));
          setShiftTransferData((create_facilitydetails: { village: any }) => ({
            ...create_facilitydetails,
            village: { ...create_facilitydetails.village, '#options': village_options }
          }));
        }
      }
      else if (type === "block") {
        if(isGrampanchayat){
          const gramPanchayat = await getDataWithCache<any>(`${endpoints.getGramPanchayatByBlockId(selected_id)}`);
          const gramPanchayatOptions = gramPanchayat?.data.map((option1: any) => ({
            value: `${option1.gram_panchayat_name}-${option1.gram_panchayat_code}`,
            label: `${option1.gram_panchayat_name}-${option1.gram_panchayat_code}`,
            id: option1.gram_panchayat_id,
            code:option1.gram_panchayat_code
          }));
          setShiftTransferData((role_details:any) => ({
            ...role_details,
            gram_panchayat: {
              ...role_details.gram_panchayat,
              '#options': gramPanchayatOptions,
             // '#required': gramPanchayatOptions?.length  ? true : false,
              '#isDisabled' : false,
            },
          }))
        }
        else {
            const postData = {
              p_state_id: userDetails?.state_id,
              p_dist_id: shiftTransferForm?.district?.id,
              p_sub_dist_ids: shiftTransferForm?.sub_district?.id ? [shiftTransferForm.sub_district.id] : [],
              p_block_ids: [selected_id],
              p_hbsd_ids: [],
            };
            const villagesResponse = await axios.post(`${endpoints.getVillagesByStateDistSubDisBlockId}`, postData, Auth.loggedInWithJSON());
            const village_options = villagesResponse?.data?.data.map((key: any) => ({
              value: key.village_name + "-" + key.village_code,
              label: key.village_name + "-" + key.village_code,
              id: key.village_id
            }));
            setShiftTransferData((create_facilitydetails: { village: any }) => ({
              ...create_facilitydetails,
              village: {...create_facilitydetails.village, '#options': village_options }
            }));
          }
        }
      else if (type === "ulb") {
        const wardResponse = await axios.get(`${endpoints.getWard(selected_id)}`, Auth.loggedIn());
        const ward_options = wardResponse?.data?.data.map((key: any) => ({
          value: key.ward_name + "-" + key.ward_code,
          label: key.ward_name + "-" + key.ward_code,
          id: key.ward_id
        }))
        setShiftTransferData((create_facilitydetails: { ward: any; }) => ({
          ...create_facilitydetails,
          ward: {
            ...create_facilitydetails.ward,
            '#options': ward_options
          }
        }))
      } else if (type === "hfr_id") {
        const mobiliserTaggedDetail = await axios.get(`${endpoints.getASHAMobiliserTagged(selected_id)}`, Auth.loggedIn());

        const mobiliser_tagged_options = mobiliserTaggedDetail.data.data.map((key: any) => ({
          value: key.f_name + " " + key.l_name,
          label: key.f_name + " " + key.l_name,
          id: key.user_id
        }));
        setCoverageShiftTransferData((create_facilitydetails: { mobiliser_tagged: any; }) => ({
          ...create_facilitydetails,
          mobiliser_tagged: {
            ...create_facilitydetails.mobiliser_tagged,
            '#options': mobiliser_tagged_options
          }
        }))
      }

    } catch(error:any){
      errorLogger(error?.response?.data||error?.response||error)
    }
  }
  
  const fecthUlbBySearch = async (ulbInputText:string) => {
      const payload = {
        stateId : userDetails.state_id,
        searchText : ulbInputText,
      }
      const getUlbwithsearch = await axios.get(`${endpoints.fetchUlbByStateIdAndSearch(userDetails.state_id, ulbInputText)}`, Auth.loggedIn());
      setShiftTransferULBs(getUlbwithsearch?.data?.data);
      const getUlb_options = getUlbwithsearch?.data.data?.map((key: any) => ({
        value: `${key.ulb_name}-${key.ulb_code}`,
        label: `${key.ulb_name}-${key.ulb_code}`,
        id: key.ulb_id,
        code: key.ulb_code,
      }));
      setShiftTransferData((hierarchy_details_urban: any) => ({
        ...hierarchy_details_urban,
        ulb: {
          ...hierarchy_details_urban.ulb,
          '#options': getUlb_options,
          '#required': true,
          '#isDisabled': false,
        },
      }));
    }
  
    useEffect(()=>{
      if(userDetails.state_id && ulbInputText?.length >= 3){
        fecthUlbBySearch(ulbInputText)
      }
      if(ulbInputText?.length === 0)
        {
          setShiftTransferData((hierarchy_details_urban: any) => ({
            ...hierarchy_details_urban,
            ulb: {
              ...hierarchy_details_urban.ulb,
              '#options': [],
            },
          }));
        }
    },[ulbInputText])
  const fetchShiftTransferData = async (districtId?:any) => {
    try {
      if(isGrampanchayat){
        setShiftTransferData((role_details: any) => ({
          ...role_details,
          village: {
            ...role_details?.village,
            '#isVisible':false,
          },
          gram_panchayat: {
            ...role_details?.gram_panchayat,
            '#isVisible':true,
          },
        }))
        setCoverageShiftTransferData((coverage_details: { villages_covered: any;gram_panchayat_covered:any }) => ({
          ...coverage_details,
          villages_covered: {
            ...coverage_details?.villages_covered,
            '#isVisible':false,
          },
          gram_panchayat_covered: {
            ...coverage_details?.gram_panchayat_covered,
            '#isVisible':true,
          },
        }));
        
      }
      else{
        setShiftTransferData((role_details: any) => ({
          ...role_details,
          village: {
            ...role_details?.village,
            '#isVisible':true,
          },
          gram_panchayat: {
            ...role_details?.gram_panchayat,
            '#isVisible':false,
          },
        }))
        setCoverageShiftTransferData((coverage_details: { villages_covered: any;gram_panchayat_covered:any }) => ({
          ...coverage_details,
          villages_covered: {
            ...coverage_details?.villages_covered,
            '#isVisible':true,
          },
          gram_panchayat_covered: {
            ...coverage_details?.gram_panchayat_covered,
            '#isVisible':false,
          },
        }));
      }

      setShiftTransferForm((prevState: any) => ({
        ...prevState,
        state: {
          ...prevState['state'],
          value: `${userDetails?.state_name}-${userDetails?.state_code}`,
        }
      }));

      const districtResponse = await axios.get(`${endpoints.getDistrictsWitoutUserId(userDetails.state_id)}`, Auth.loggedIn());
      setShiftTransferDistricts(districtResponse?.data?.data)
      const district_options = districtResponse?.data?.data.map((key: any) => ({
        value: key.district_name + "-" + key.district_code,
        label: key.district_name + "-" + key.district_code,
        id: key.district_id,
        code: key.district_code,
      }))
     
      setShiftTransferData((create_facilitydetails: { district: any; ulb: any; state: any; }) => ({
        ...create_facilitydetails,
        district: {
          ...create_facilitydetails.district,
          '#options': district_options,
        },
        state: {
          ...create_facilitydetails.state,
          "#isDisabled": true,
        },
      }))
    } catch(error:any){
      errorLogger(error?.response?.data||error?.response||error)
    }

  }
  
  const fetchAndReturnHFRIdTypeAndName = async(id:any,key:string, excludeLinkedFacilities = false)=>{
    let facility:any;
    if(key === "village"){
      const params ={
        p_village_id:id ?? userDetails?.village_id,
        p_facilitytype_id:'',
        p_search_facility:'' 
      }
      facility = await getDataParams<any[]>(`${endpoints.getFacilityByVillage}`,params);
    }else if(key === "ward"){
      const params ={
        p_ward_id:id ?? userDetails?.ward_id,
        p_facilitytype_id:'',
        p_search_facility:'' 
      }
      facility = await getDataParams<any[]>(`${endpoints.getFacilityByWard}`,params);
    }else if(key === "gram_panchayat"){
      const params ={
        p_gram_panchayat_id:id ?? userDetails?.gram_panchayat_id,
        p_facilitytype_id:'',
        p_search_facility:'' 
      }
      facility = await getDataParams<any[]>(`${endpoints.getFacilityByGramPanchayat}`,params);
    }else{
      const facility_details_body = {
        "p_st_id": userDetails?.state_id,
        "p_dist_id": id ? id : userDetails?.district_id,
        "p_facilitytype_id": null,
        "p_search_facility": null
      }
      const facilityResponse = await axios.post(endpoints.getFacilityByNameDist, facility_details_body, Auth.loggedInWithJSON())
      facility = facilityResponse.data;
    }

    const hfr_ids: any[] = [];
    const hfr_names: any[] = [];

    if (excludeLinkedFacilities) {
      facilityDetails.forEach((key: any) => {
        if (key?.is_linked === true && key?.hfr_id) {
          hfr_ids.push(key.hfr_id);
        }

        const name = key?.facility_name?.value;
        if (key?.is_linked === true && name) {
          hfr_names.push(name);
        }
      });
    }

    const filteredFacilities = facility.data.filter((key: any) => {
      return !excludeLinkedFacilities || !hfr_ids.includes(key.hfr_id);
    })
    setFacilityDetails1(filteredFacilities);
    let facility_hfr_options = filteredFacilities.map((key: any) => ({
      value: key.hfr_id,
      label: key.hfr_id,
      id: key.facility_type_id
    }))

    facility_hfr_options = facility_hfr_options.filter((key: any) => {
      return key.value;
    });

    let facility_name_options = filteredFacilities.map((key: any) => ({
      value: key.facility_name,
      label: key.facility_name,
      id: key.facility_type_id
    }))

    facility_name_options = facility_name_options.filter((key: any) => {
      return key.value;
    })
    return {facility_hfr_options,facility_name_options};
  }

  const workflowExistsForApproval = async () => {
    let pendingWorkflow = false
    let approvalReqId = '';
    let approvalReqStatus = '';
    let reqefectiveData = '';
    try {
      const reqBody = {
        requestForType: 'User',
        requestForId: id
      }
      const facility_details_response = await axios.post(endpoints.workflowExistsForApproval, reqBody, Auth.loggedInWithJSON())
      pendingWorkflow = facility_details_response?.data?.data?.check_workflow_exists_for_approval;
      approvalReqId = facility_details_response?.data?.data?.request_serial_id || '';
      approvalReqStatus = facility_details_response?.data?.data?.v_status_name || '';
      reqefectiveData = facility_details_response?.data?.data?.effective_from_date ? dayjs(facility_details_response?.data?.data?.effective_from_date).format(dateFormate.dd_mm_yyyy) : '';
    } catch(error: any) {
      errorLogger(error?.response?.data||error?.response||error)
    }
    setDisableShiftTransferBtn(!!pendingWorkflow);
    setApprovalReqId(approvalReqId);
    setApprovalReqStatus(approvalReqStatus);
    setReqefectiveData(reqefectiveData);
  }

  const handleShiftTransferPage = async () => {
    setShowShiftTransfer(true)
    await fetchShiftTransferData()
  }

  const handleShiftTransfer = async () => {
    if (LogedinUserDetails && LogedinUserDetails?.usertype_name === USER_TYPES.DISTRICT_LEVEL_USER && (roleData == roleType.both || roleData == roleType.only_administrator)) {
      const checkUsersSessionExists = await axios.get(`${endpoints.getUsersSessionExists(id)}`, Auth.loggedIn());
      if (checkUsersSessionExists && checkUsersSessionExists?.data?.data[0]?.check_upcoming_vhnd_exists) {
        toast.warning(errorSuccessMessage.checkUserSessionExists, {
          position: "top-center"
        });
      } else {
        handleShiftTransferPage();
      }
    } else {
      handleShiftTransferPage();
    }
  }
  const handleInputChange=_.debounce((value:string, key:string)=>{
      if(key === 'ulb'){
        setUlbInputText(value.trim());
      }
    },500);

  const handleFormChange = async (value: any, key: string, id?: any, option?: any, code?: any, field?: formDataType | undefined) => {

    if (value && key === 'hfr_id') {
      const facilityDetail = facilityDetails1?.find((item: any) => item.hfr_id === value);

      setHealthProviderForm((prevState: any) => ({
        ...prevState,
        health_facility_name: {
          ...prevState['health_facility_name'],
          value: facilityDetail.facility_name,
          isError: false,
          message: '',
          id: facilityDetail.facilit_id,
        },
        health_facility_type: {
          ...prevState['health_facility_type'],
          value: facilityDetail.facility_type,
          isError: false,
          message: '',
          id: facilityDetail.facility_type_id,
        },
      }));

      await fetchVillageWardAndAsha(facilityDetail.facilit_id);

    } else if (!value && key === "hfr_id") {
      setHealthProviderForm((prevState: any) => ({
        ...prevState,
        mobiliser_tagged: {
          ...prevState.mobiliser_tagged,
          value: '',
          id: ''
        },
        wards_covered: {
          ...prevState.wards_covered,
          value: [],
          id: []
        },
        villages_covered: {
          ...prevState.villages_covered,
          value: [],
          id: []
        },
        gram_panchayat_covered: {
          ...prevState.gram_panchayat_covered,
          value: [],
          id: []
        },
        health_facility_name: {
          ...prevState.health_facility_name,
          value: '',
          id: ''
        },
        health_facility_type: {
          ...prevState.health_facility_type,
          value: '',
          id: ''
        },

      }));

      let facility_hfr_options = facilityDetails1?.map((key: any) => ({
        value: key.hfr_id,
        label: key.hfr_id,
        id: key.facility_type_id
      }))

      let facility_name_options = facilityDetails1?.map((key: any) => ({
        value: key.facility_name,
        label: key.facility_name,
        id: key.facility_type_id
      }))

      facility_hfr_options = facility_hfr_options?.filter((key) => key.value);
      facility_name_options = facility_name_options?.filter((key) => key.value)

      setHealthProviderData((create_facilitydetails: { wards_covered: any,villages_covered:any,gram_panchayat_covered:any, mobiliser_tagged: any, health_facility_name: any, health_facility_type: any, hfr_id: any, }) => ({
        ...create_facilitydetails,
        wards_covered: {
          ...create_facilitydetails.wards_covered,
          '#options': [],
        },
        villages_covered: {
          ...create_facilitydetails.villages_covered,
          '#options': [],
        },
        gram_panchayat_covered: {
          ...create_facilitydetails.gram_panchayat_covered,
          '#options': [],
        },
        mobiliser_tagged: {
          ...create_facilitydetails.mobiliser_tagged,
          '#options': [],
        },
        hfr_id: {
          ...create_facilitydetails.hfr_id,
          '#options': facility_hfr_options,
        },
        health_facility_name: {
          ...create_facilitydetails.health_facility_name,
          '#options': facility_name_options,
        },
      }));
    } else if (value && key === 'health_facility_name') {
      const facilityDetail = facilityDetails1?.find((item: any) => item.facility_name === value);

      await fetchVillageWardAndAsha(facilityDetail.facilit_id);

      setHealthProviderForm((prevState: any) => ({
        ...prevState,
        hfr_id: {
          ...prevState[key],
          value: facilityDetail.hfr_id,
          isError: false,
          message: '',
          id: facilityDetail.facilit_id,
        },
        health_facility_type: {
          ...prevState[key],
          value: facilityDetail.facility_type,
          isError: false,
          message: '',
          id: facilityDetail.facility_type_id,
        },
      }));
    } else if (!value && key === 'health_facility_name') {
      setHealthProviderForm((prevState: any) => ({
        ...prevState,
        mobiliser_tagged: {
          ...prevState.mobiliser_tagged,
          value: '',
          id: ''
        },
        wards_covered: {
          ...prevState.wards_covered,
          value: [],
          id: []
        },
        villages_covered: {
          ...prevState.villages_covered,
          value: [],
          id: []
        },
        gram_panchayat_covered: {
          ...prevState.gram_panchayat_covered,
          value: [],
          id: []
        },
        hfr_id: {
          ...prevState.hfr_id,
          value: '',
          id: ''
        },
        health_facility_type: {
          ...prevState.health_facility_type,
          value: '',
          id: ''
        },

      }));

      let facility_hfr_options = facilityDetails1?.map((key: any) => ({
        value: key.hfr_id,
        label: key.hfr_id,
        id: key.facility_type_id
      }))

      let facility_name_options = facilityDetails1?.map((key: any) => ({
        value: key.facility_name,
        label: key.facility_name,
        id: key.facility_type_id
      }))

      facility_hfr_options = facility_hfr_options?.filter((key) => key.value);
      facility_name_options = facility_name_options?.filter((key) => key.value)

      setHealthProviderData((create_facilitydetails: { wards_covered: any,villages_covered:any,gram_panchayat_covered:any, mobiliser_tagged: any, hfr_id: any, health_facility_name: any }) => ({
        ...create_facilitydetails,
        wards_covered: {
          ...create_facilitydetails.wards_covered,
          '#options': [],
        },
        villages_covered: {
          ...create_facilitydetails.villages_covered,
          '#options': [],
        },
        gram_panchayat_covered: {
          ...create_facilitydetails.gram_panchayat_covered,
          '#options': [],
        },
        mobiliser_tagged: {
          ...create_facilitydetails.mobiliser_tagged,
          '#options': [],
        },
        hfr_id: {
          ...create_facilitydetails.hfr_id,
          '#options': facility_hfr_options,
        },
        health_facility_name: {
          ...create_facilitydetails.health_facility_name,
          '#options': facility_name_options,
        }
      }));
    } else if (!value && key === 'health_facility_type') {
      setHealthProviderForm((prevState: any) => ({
        ...prevState,
        mobiliser_tagged: {
          ...prevState.mobiliser_tagged,
          value: '',
          id: ''
        },
        wards_covered: {
          ...prevState.wards_covered,
          value: [],
          id: []
        },
        villages_covered: {
          ...prevState.villages_covered,
          value: [],
          id: []
        },
        gram_panchayat_covered: {
          ...prevState.gram_panchayat_covered,
          value: [],
          id: []
        },
        hfr_id: {
          ...prevState.hfr_id,
          value: '',
          id: ''
        },
        health_facility_name: {
          ...prevState.health_facility_name,
          value: '',
          id: ''
        },

      }));

      let facility_hfr_options = facilityDetails1?.map((key: any) => ({
        value: key.hfr_id,
        label: key.hfr_id,
        id: key.facility_type_id
      }))

      let facility_name_options = facilityDetails1?.map((key: any) => ({
        value: key.facility_name,
        label: key.facility_name,
        id: key.facility_type_id
      }))

      facility_hfr_options = facility_hfr_options?.filter((key) => key.value);
      facility_name_options = facility_name_options?.filter((key) => key.value)


      setHealthProviderData((create_facilitydetails: { wards_covered: any,villages_covered:any,gram_panchayat_covered:any, mobiliser_tagged: any, hfr_id: any, health_facility_name: any; }) => ({
        ...create_facilitydetails,
        wards_covered: {
          ...create_facilitydetails.wards_covered,
          '#options': [],
        },
        villages_covered: {
          ...create_facilitydetails.villages_covered,
          '#options': [],
        },
        gram_panchayat_covered: {
          ...create_facilitydetails.gram_panchayat_covered,
          '#options': [],
        },
        mobiliser_tagged: {
          ...create_facilitydetails.mobiliser_tagged,
          '#options': [],
        },
        hfr_id: {
          ...create_facilitydetails.hfr_id,
          '#options': facility_hfr_options,
        },
        health_facility_name: {
          ...create_facilitydetails.health_facility_name,
          '#options': facility_name_options,
        },
      }));
    } else if (value && key === 'health_facility_type') {
      const filteredFacilityDetails: any[] = facilityDetails1?.filter((item: any) => item.facility_type === value && item.hfr_id && item.facility_name) || [];
      setHealthProviderForm((prevState: any) => ({
        ...prevState,
        mobiliser_tagged: {
          ...prevState.mobiliser_tagged,
          value: '',
          id: ''
        },
        wards_covered: {
          ...prevState.wards_covered,
          value: [],
          id: []
        },
        villages_covered: {
          ...prevState.villages_covered,
          value: [],
          id: []
        },
        gram_panchayat_covered: {
          ...prevState.gram_panchayat_covered,
          value: [],
          id: []
        },
        hfr_id: {
          ...prevState.hfr_id,
          value: '',
          id: ''
        },
        health_facility_name: {
          ...prevState.health_facility_name,
          value: '',
          id: ''
        },
      }));

      const facility_hfr_options = filteredFacilityDetails.map((key: any) => ({
        value: key.hfr_id,
        label: key.hfr_id,
        id: key.facility_type_id
      }))

      const facility_name_options = filteredFacilityDetails.map((key: any) => ({
        value: key.facility_name,
        label: key.facility_name,
        id: key.facility_type_id
      }))

      setHealthProviderData((create_facilitydetails: { wards_covered: any,villages_covered:any,gram_panchayat_covered:any, mobiliser_tagged: any, hfr_id: any, health_facility_name: any; }) => ({
        ...create_facilitydetails,
        wards_covered: {
          ...create_facilitydetails.wards_covered,
          '#options': [],
        },
        villages_covered: {
          ...create_facilitydetails.villages_covered,
          '#options': [],
        },
        gram_panchayat_covered: {
          ...create_facilitydetails.gram_panchayat_covered,
          '#options': [],
        },
        mobiliser_tagged: {
          ...create_facilitydetails.mobiliser_tagged,
          '#options': [],
        },
        health_facility_name: {
          ...create_facilitydetails.health_facility_name,
          '#options': facility_name_options,
        },
        hfr_id: {
          ...create_facilitydetails.hfr_id,
          '#options': facility_hfr_options,
        },

      }));
    } else if (value && key === 'remarks' && value.length > 30) {
      return;
    }
    setHealthProviderForm((prevState: any) => ({
      ...prevState,
      [key]: {
        ...prevState[key],
        value: value,
        isError: false,
        message: '',
        id: id,
        code: code
      },
    }));
  }
  const handleShiftTransFerFormChange = async (value: any, key: string, id?: any, option?: any, code?: any, field?: formDataType | undefined) => {
    if (value && key === "district") {
        setShiftTransferForm((prevState: any) => ({
          ...prevState,
          district: {
            ...prevState['district'],
            value: value,
            id: id,
          },
          sub_district: {
            ...prevState['sub_district'],
            value: '',
            isError: false,
            message: '',
            id: '',
          },
          block: {
            ...prevState['block'],
            value: '',
            isError: false,
            message: '',
            id: '',
          },
        }));
      const shiftTransferDistrict = shiftTransferDistricts.find((item: any) => item.district_name + '-' + item.district_code === value);
      await fetchShiftFieldOptionsById(shiftTransferDistrict.district_id, "district");
      setCoverageShiftTransferForm((prevState: any) => ({
        ...prevState,
        health_facility_name: {
          ...prevState['health_facility_name'],
          value: '',
        },
        health_facility_type: {
          ...prevState['health_facility_type'],
          value: '',
        },
        hfr_id: {
          ...prevState['hfr_id'],
          value: '',
        },
        
      }))
      setCoverageShiftTransferData((prevState: any) => ({
        ...prevState,
        health_facility_name: {
          ...prevState.health_facility_name,
          '#isDisabled':false
        },
        health_facility_type: {
          ...prevState.health_facility_type,
          '#isDisabled':false
        },
        hfr_id: {
          ...prevState.hfr_id,
          '#isDisabled':false
        },
      }));
    } else if (!value && key === "district") {
      setShiftTransferForm((prevState: any) => ({
        ...prevState,
        sub_district: {
          ...prevState['sub_district'],
          value: '',
          isError: false,
          message: '',
          id: '',
        },
        block: {
          ...prevState['block'],
          value: '',
          isError: false,
          message: '',
          id: '',
        },
        health_block: {
          ...prevState['health_block'],
          value: '',
          isError: false,
          message: '',
          id: '',
        },
        sub_division: {
          ...prevState['sub_division'],
          value: '',
          isError: false,
          message: '',
          id: '',
        },
        village: {
          ...prevState['village'],
          value: '',
          isError: false,
          message: '',
          id: '',
        },
        gram_panchayat: {
          ...prevState['gram_panchayat'],
          value: '',
          isError: false,
          message: '',
          id: '',
        },
        rural_urban:{
          ...prevState['rural_urban'],
          value: '',
          isError: false,
          message: '',
          id: '',
        },
        ulb: {
          ...prevState.ulb,
          value: '',
          id: ''
        },
        ward: {
          ...prevState.ward,
          value: '',
          id: ''
        }
      }));
      setShiftTransferData((create_facilitydetails: { sub_district: any; block: any; health_block: any; sub_division: any; village: any;gram_panchayat:any }) => ({
        ...create_facilitydetails,
        sub_district: {
          ...create_facilitydetails.sub_district,
          '#options': [],
        },
        block: {
          ...create_facilitydetails.block,
          '#options': [],
        },
        health_block: {
          ...create_facilitydetails.health_block,
          '#options': [],
        },
        sub_division: {
          ...create_facilitydetails.sub_division,
          '#options': [],
        },
        village: {
          ...create_facilitydetails.village,
          '#options': [],
        },
        gram_panchayat: {
          ...create_facilitydetails.gram_panchayat,
          '#options': [],
        },
      }))
      setCoverageShiftTransferData((prevState: any) => ({
        ...prevState,
        health_facility_name: {
          ...prevState.health_facility_name,
          '#isDisabled':false
        },
        health_facility_type: {
          ...prevState.health_facility_type,
          '#isDisabled':false
        },
        hfr_id: {
          ...prevState.hfr_id,
          '#isDisabled':false
        },
      }));
      setCoverageShiftTransferForm((prevState: any) => ({
        ...prevState,
        ...coverageShiftTransferObj
      }));
    }
    else if (value && key === "sub_district") {
      setShiftTransferForm((prevState: any) => ({
        ...prevState,
        village: { ...prevState.village, value: '', isError: false, message: '', id: '' },
        gram_panchayat: { ...prevState.gram_panchayat, value: '', isError: false, message: '', id: '' },
      }));
      await fetchShiftFieldOptionsById(id, "sub_district");
    } else if (!value && key === "sub_district") {
      setShiftTransferForm((prevState: any) => ({
        ...prevState,
        village: { ...prevState.village, value: '', isError: false, message: '', id: '' },
        gram_panchayat: { ...prevState.gram_panchayat, value: '', isError: false, message: '', id: '' },
      }));
      setShiftTransferData((create_facilitydetails: { village: any; gram_panchayat: any }) => ({
        ...create_facilitydetails,
        village: { ...create_facilitydetails.village, '#options': [] },
        gram_panchayat: { ...create_facilitydetails.gram_panchayat, '#options': [] },
      }));
    }
    else if (value && key === "block") {
      const shiftTransferBlock = shiftTransferBlocks.find((item: any) => item.block_name + '-' + item.block_code === value);
      setShiftTransferForm((prevState: any) => ({
        ...prevState,
        village: {
          ...prevState['village'],
          value: '',
          isError: false,
          message: '',
          id: '',
        },
        gram_panchayat: {
          ...prevState['gram_panchayat'],
          value: '',
          isError: false,
          message: '',
          id: '',
        },
      }));
      await fetchShiftFieldOptionsById(shiftTransferBlock.block_id, "block");
    } else if (!value && key === "block") {
      setShiftTransferForm((prevState: any) => ({
        ...prevState,
        village: {
          ...prevState['village'],
          value: '',
          isError: false,
          message: '',
          id: '',
        },
        gram_panchayat: {
          ...prevState['gram_panchayat'],
          value: '',
          isError: false,
          message: '',
          id: '',
        },
      }));

      setShiftTransferData((create_facilitydetails: { village: any;gram_panchayat:any }) => ({
        ...create_facilitydetails,
        village: {
          ...create_facilitydetails.village,
          '#options': [],
        },
        gram_panchayat: {
          ...create_facilitydetails.gram_panchayat,
          '#options': [],
        },
      }));
    }
    else if (value && key === "ulb") {
      const shiftTransferULB = shiftTransferULBs?.find((item: any) => item.ulb_name + "-" + item.ulb_code === value);
      setShiftTransferForm((prevState: any) => ({
        ...prevState,
        ward: {
          ...prevState['ward'],
          value: '',
          isError: false,
          message: '',
          id: '',
        }
      }));
      await fetchShiftFieldOptionsById(shiftTransferULB?.ulb_id, "ulb");
    } else if (!value && key === "ulb") {
      setShiftTransferForm((prevState: any) => ({
        ...prevState,
        ward: {
          ...prevState['ward'],
          value: '',
          isError: false,
          message: '',
          id: '',
        }
      }));

      setShiftTransferData((create_facilitydetails: { ward: any; }) => ({
        ...create_facilitydetails,
        ward: {
          ...create_facilitydetails.ward,
          '#options': [],
        },
      }));

    }

    else if (value && key === "hfr_id") {
      const facilityDetail = facilityDetails1?.find((item: any) => item.hfr_id === value);
      setCoverageShiftTransferForm((prevState: any) => ({
        ...prevState,
        health_facility_name: {
          ...prevState['health_facility_name'],
          value: facilityDetail?.facility_name,
          isError: false,
          message: '',
          id: facilityDetail?.facilit_id,
        },
        health_facility_type: {
          ...prevState['health_facility_type'],
          value: facilityDetail?.facility_type,
          isError: false,
          message: '',
          id: facilityDetail?.facility_type_id,
        },
      }));
      setCoverageShiftTransferData((create_facilitydetails: { health_facility_type: any, health_facility_name: any; }) => ({
        ...create_facilitydetails,
        health_facility_type: {
          ...create_facilitydetails.health_facility_type,
          '#isDisabled': true
        },
        health_facility_name: {
          ...create_facilitydetails.health_facility_name,
          '#isDisabled': true
        },
      }));
      await fetchShiftFieldOptionsById(facilityDetail?.facilit_id, "hfr_id");
      await fetchVillageWardAndAshaShiftTransfer(facilityDetail?.facilit_id);
    } else if (value && key === 'health_facility_name') {
      const facilityDetail = facilityDetails1?.find((item: any) => item?.facility_name === value);

      setCoverageShiftTransferForm((prevState: any) => ({
        ...prevState,
        hfr_id: {
          ...prevState[key],
          value: facilityDetail.hfr_id,
          isError: false,
          message: '',
          id: facilityDetail.facilit_id,
        },
        health_facility_type: {
          ...prevState[key],
          value: facilityDetail.facility_type,
          isError: false,
          message: '',
          id: facilityDetail.facility_type_id,
        },
      }));
      setCoverageShiftTransferData((create_facilitydetails: { health_facility_type: any, hfr_id: any; }) => ({
        ...create_facilitydetails,
        hfr_id: {
          ...create_facilitydetails.hfr_id,
          '#isDisabled': true
        },
        health_facility_type: {
          ...create_facilitydetails.health_facility_type,
          '#isDisabled': true
        },
      }));
      await fetchShiftFieldOptionsById(facilityDetail.facilit_id, "hfr_id");
      await fetchVillageWardAndAshaShiftTransfer(facilityDetail.facilit_id);

    } else if (!value && key === "hfr_id") {
      setCoverageShiftTransferForm((prevState: any) => ({
        ...prevState,
        mobiliser_tagged: {
          ...prevState.mobiliser_tagged,
          value: '',
          id: ''
        },
        health_facility_name: {
          ...prevState.health_facility_name,
          value: '',
          id: ''
        },
        health_facility_type: {
          ...prevState.health_facility_type,
          value: '',
          id: ''
        },
        wards_covered: {
          ...prevState.wards_covered,
          value: [],
          id: []
        },
        villages_covered: {
          ...prevState.villages_covered,
          value: [],
          id: []
        },
        gram_panchayat_covered: {
          ...prevState.gram_panchayat_covered,
          value: [],
          id: []
        },

      }));
      setCoverageShiftTransferData((create_facilitydetails: { mobiliser_tagged: any, health_facility_type: any, health_facility_name: any }) => ({
        ...create_facilitydetails,
        mobiliser_tagged: {
          ...create_facilitydetails.mobiliser_tagged,
          '#options': [],
        },
        health_facility_type: {
          ...create_facilitydetails.health_facility_type,
          '#isDisabled': false
        },
        health_facility_name: {
          ...create_facilitydetails.health_facility_name,
          '#isDisabled': false
        },
      }));
    } else if (!value && key === 'health_facility_name') {
      setCoverageShiftTransferForm((prevState: any) => ({
        ...prevState,
        mobiliser_tagged: {
          ...prevState.mobiliser_tagged,
          value: '',
          id: ''
        },
        hfr_id: {
          ...prevState.hfr_id,
          value: '',
          id: ''
        },
        health_facility_type: {
          ...prevState.health_facility_type,
          value: '',
          id: ''
        },
        wards_covered: {
          ...prevState.wards_covered,
          value: [],
          id: []
        },
        villages_covered: {
          ...prevState.villages_covered,
          value: [],
          id: []
        },
        gram_panchayat_covered: {
          ...prevState.gram_panchayat_covered,
          value: [],
          id: []
        },

      }));
      setCoverageShiftTransferData((create_facilitydetails: { mobiliser_tagged: any, health_facility_type: any, hfr_id: any }) => ({
        ...create_facilitydetails,
        mobiliser_tagged: {
          ...create_facilitydetails.mobiliser_tagged,
          '#options': [],
        },
        hfr_id: {
          ...create_facilitydetails.hfr_id,
          '#isDisabled': false
        },
        health_facility_type: {
          ...create_facilitydetails.health_facility_type,
          '#isDisabled': false
        },
      }));
    } else if (value && key === 'health_facility_type') {
      const filteredFacilityDetails: any[] = facilityDetails1?.filter((item: any) => item.facility_type === value && item.hfr_id && item.facility_name) || [];
      const facility_hfr_options = filteredFacilityDetails?.map((key: any) => ({
        value: key.hfr_id,
        label: key.hfr_id,
        id: key.facility_type_id
      }))

      const facility_name_options = filteredFacilityDetails?.map((key: any) => ({
        value: key.facility_name,
        label: key.facility_name,
        id: key.facility_type_id
      }))

      setCoverageShiftTransferForm((prevState: any) => ({
        ...prevState,
        mobiliser_tagged: {
          ...prevState.mobiliser_tagged,
          value: '',
          id: ''
        },
        hfr_id: {
          ...prevState.hfr_id,
          value: '',
          id: ''
        },
        health_facility_name: {
          ...prevState.health_facility_name,
          value: '',
          id: ''
        },
      }));
      setCoverageShiftTransferData((create_facilitydetails: { mobiliser_tagged: any,wards_covered:any;villages_covered:any; gram_panchayat_covered: any, hfr_id: any, health_facility_name: any; }) => ({
        ...create_facilitydetails,
        mobiliser_tagged: {
          ...create_facilitydetails.mobiliser_tagged,
          '#options': [],
        },
        wards_covered: {
          ...create_facilitydetails.wards_covered,
          '#options': [],
        },
        villages_covered: {
          ...create_facilitydetails.villages_covered,
          '#options': [],
        },
        gram_panchayat_covered: {
          ...create_facilitydetails.gram_panchayat_covered,
          '#options': [],
        },
        health_facility_name: {
          ...create_facilitydetails.health_facility_name,
          '#options': facility_name_options,
        },
        hfr_id: {
          ...create_facilitydetails.hfr_id,
          '#options': facility_hfr_options,
        },
      }));
    } else if (!value && key === 'health_facility_type') {
      setCoverageShiftTransferForm((prevState: any) => ({
        ...prevState,
        mobiliser_tagged: {
          ...prevState.mobiliser_tagged,
          value: '',
          id: ''
        },
        hfr_id: {
          ...prevState.hfr_id,
          value: '',
          id: ''
        },
        health_facility_name: {
          ...prevState.health_facility_name,
          value: '',
          id: ''
        },
        wards_covered: {
          ...prevState.wards_covered,
          value: [],
          id: []
        },
        villages_covered: {
          ...prevState.villages_covered,
          value: [],
          id: []
        },
        gram_panchayat_covered: {
          ...prevState.gram_panchayat_covered,
          value: [],
          id: []
        },

      }));

      let facility_hfr_options = facilityDetails1?.map((key: any) => ({
        value: key.hfr_id,
        label: key.hfr_id,
        id: key.facility_type_id
      }))

      let facility_name_options = facilityDetails1?.map((key: any) => ({
        value: key.facility_name,
        label: key.facility_name,
        id: key.facility_type_id
      }))

      facility_hfr_options = facility_hfr_options?.filter((key) => key.value);
      facility_name_options = facility_name_options?.filter((key) => key.value)

      setCoverageShiftTransferData((create_facilitydetails: { mobiliser_tagged: any; }) => ({
        ...create_facilitydetails,
        mobiliser_tagged: {
          ...create_facilitydetails.mobiliser_tagged,
          '#options': [],
        },
      }));

      setCoverageShiftTransferData((create_facilitydetails: { mobiliser_tagged: any,wards_covered:any, villages_covered: any,gram_panchayat_covered:any, hfr_id: any, health_facility_name: any; }) => ({
        ...create_facilitydetails,
        mobiliser_tagged: {
          ...create_facilitydetails.mobiliser_tagged,
          '#options': [],
        },
        wards_covered: {
          ...create_facilitydetails.wards_covered,
          '#options': [],
        },
        villages_covered: {
          ...create_facilitydetails.villages_covered,
          '#options': [],
        },
        gram_panchayat_covered: {
          ...create_facilitydetails.gram_panchayat_covered,
          '#options': [],
        },
        health_facility_name: {
          ...create_facilitydetails.health_facility_name,
          '#options': facility_name_options,
        },
        hfr_id: {
          ...create_facilitydetails.hfr_id,
          '#options': facility_hfr_options,
        },
      }));

    } else if (value && key === "rural_urban") {
      setShiftTransferRuralUrban(value);
      setShiftTransferRuralUrbanId(id);
      value === "Urban" ?
        setShiftTransferForm((prevState: any) => ({
          ...prevState,
          village: {
            ...prevState.village,
            value: '',
            id: '',
            isError:false,
            message:'',
          },
          gram_panchayat: {
            ...prevState.gram_panchayat,
            value: '',
            id: '',
            isError:false,
            message:'',
          },
          block: {
            ...prevState.block,
            value: '',
            id: '',
            isError:false,
            message:'',
          },
        }))
        : setShiftTransferForm((prevState: any) => ({
          ...prevState,
          ulb: {
            ...prevState.ulb,
            value: '',
            id: '',
            isError:false,
            message:'',
          },
          ward: {
            ...prevState.ward,
            value: '',
            id: '',
            isError:false,
            message:'',
          },
        }))
    } else if (!value && key === "rural_urban") {
      setShiftTransferRuralUrban('')
      setShiftTransferRuralUrbanId('');
      setShiftTransferForm((prevState: any) => ({
        ...prevState,
        village: {
          ...prevState.village,
          value: '',
          id: '',
          isError:false,
          message:'',
        },
        gram_panchayat: {
          ...prevState.gram_panchayat,
          value: '',
          id: '',
          isError:false,
          message:'',
        },
        block: {
          ...prevState.block,
          value: '',
          id: '',
          isError:false,
          message:'',
        },
        ulb: {
          ...prevState.ulb,
          value: '',
          id: '',
          isError:false,
          message:'',
        },
        ward: {
          ...prevState.ward,
          value: '',
          id: '',
          isError:false,
          message:'',
        },
      }))
    }
    else if(value && key === "village"){
      setShiftTransferForm((prevState: any) => ({
        ...prevState,
        village: {
          ...prevState.village,
          value: value,
          id: id,
          isError:false,
          message:'',
        },
      }))
      const {facility_hfr_options,facility_name_options} = await fetchAndReturnHFRIdTypeAndName(id,key);
      setCoverageShiftTransferData((create_facilitydetails: { health_facility_name: any; hfr_id: any, health_facility_type: any }) => ({
        ...create_facilitydetails,
        health_facility_name: {
          ...create_facilitydetails.health_facility_name,
          '#options': facility_name_options,
        },
        hfr_id: {
          ...create_facilitydetails.hfr_id,
          '#options': facility_hfr_options,
        },
      }));

    }else if(!value && key === "village"){
      setShiftTransferForm((prevState: any) => ({
        ...prevState,
        village: {
          ...prevState.village,
          value: '',
          id: '',
        },
      }))
      setCoverageShiftTransferData((create_facilitydetails: { health_facility_name: any; hfr_id: any, health_facility_type: any }) => ({
        ...create_facilitydetails,
        health_facility_name: {
          ...create_facilitydetails.health_facility_name,
          '#options': [],
        },
        hfr_id: {
          ...create_facilitydetails.hfr_id,
          '#options': [],
        },
      }));
    }
    else if(value && key === "ward"){
      setShiftTransferForm((prevState: any) => ({
        ...prevState,
        ward: {
          ...prevState.ward,
          value: value,
          id: id,
          isError:false,
          message:'',
        },
      }))
      const {facility_hfr_options,facility_name_options} = await fetchAndReturnHFRIdTypeAndName(id,key);
      setCoverageShiftTransferData((create_facilitydetails: { health_facility_name: any; hfr_id: any, health_facility_type: any }) => ({
        ...create_facilitydetails,
        health_facility_name: {
          ...create_facilitydetails.health_facility_name,
          '#options': facility_name_options,
        },
        hfr_id: {
          ...create_facilitydetails.hfr_id,
          '#options': facility_hfr_options,
        },
      }));

    }else if(!value && key === "ward"){
      setShiftTransferForm((prevState: any) => ({
        ...prevState,
        ward: {
          ...prevState.ward,
          value: '',
          id: '',
        },
      }))
      setCoverageShiftTransferData((create_facilitydetails: { health_facility_name: any; hfr_id: any, health_facility_type: any }) => ({
        ...create_facilitydetails,
        health_facility_name: {
          ...create_facilitydetails.health_facility_name,
          '#options': [],
        },
        hfr_id: {
          ...create_facilitydetails.hfr_id,
          '#options': [],
        },
      }));
    }
    else if(value && key === "gram_panchayat"){
      setShiftTransferForm((prevState: any) => ({
        ...prevState,
        gram_panchayat: {
          ...prevState.gram_panchayat,
          value: value,
          id: id,
          isError:false,
          message:'',
        },
      }))
      const {facility_hfr_options,facility_name_options} = await fetchAndReturnHFRIdTypeAndName(id,key);
      setCoverageShiftTransferData((create_facilitydetails: { health_facility_name: any; hfr_id: any, health_facility_type: any }) => ({
        ...create_facilitydetails,
        health_facility_name: {
          ...create_facilitydetails.health_facility_name,
          '#options': facility_name_options,
        },
        hfr_id: {
          ...create_facilitydetails.hfr_id,
          '#options': facility_hfr_options,
        },
      }));

    }else if(!value && key === "gram_panchayat"){
      setShiftTransferForm((prevState: any) => ({
        ...prevState,
        gram_panchayat: {
          ...prevState.gram_panchayat,
          value: '',
          id: '',
        },
      }))
      setCoverageShiftTransferData((create_facilitydetails: { health_facility_name: any; hfr_id: any, health_facility_type: any }) => ({
        ...create_facilitydetails,
        health_facility_name: {
          ...create_facilitydetails.health_facility_name,
          '#options': [],
        },
        hfr_id: {
          ...create_facilitydetails.hfr_id,
          '#options': [],
        },
      }));
    }
    if (key === 'health_facility_type' || key === "hfr_id" || key === "health_facility_name" || key === "villages_covered"||key==='wards_covered'||key==='gram_panchayat_covered' || key === "mobiliser_tagged") {
      setCoverageShiftTransferForm((prevState: any) => ({
        ...prevState,
        [key]: {
          ...prevState[key],
          value: value,
          isError: false,
          message: '',
          id: id,
          code: code
        },
      }))
    }
    setCoverageShiftTransferForm((prevState: any) => ({
      ...prevState,
      health_facility_name: {
        ...prevState.health_facility_name,
        isError: false,
        message: '',
      },
      hfr_id: {
        ...prevState.hfr_id,
        isError: false,
        message: '',
      },
      health_facility_type: {
        ...prevState.health_facility_type,
        isError: false,
        message: '',
      },
    }));
    setShiftTransferForm((prevState: any) => ({
      ...prevState,
      [key]: {
        ...prevState[key],
        value: value,
        isError: false,
        message: '',
        id: id,
        code: code
      },
    }));
  }

  return (
    <>
      <div className="overview_health_block">
      {disableShiftTransferBtn ? <><h6><strong>{setStatusMessage(approvalReqStatus, reqefectiveData, approvalReqId, 'shift/transfer')}</strong></h6></> : <></>}
        <div className='overview-details-table'>
          {!showShiftTransfer && <BadgesComponent
            className="over-badge"
            badgeName={`${showShiftTransfer ? "Current Facility details" : "Facility details"}`}
            variant="primary-1"
            badgeType="case5"
          />}
          {(isLinkingMultipleFacilities || showShiftTransfer || showEditLinkedFacility) && <br />}
          {!(showShiftTransfer || isLinkingMultipleFacilities || showEditLinkedFacility) && <div className='button_wrapper_main'>
            {canCreateUser && (
              <Button
                onClick={() => {
                  setLinkedFacilityForm((prevState) => ({
                    ...prevState,
                    hfr_id: {
                      ...prevState['hfr_id'],
                      value: '',
                      isError: false,
                      message: ''
                    },
                    health_facility_type: {
                      ...prevState['health_facility_type'],
                      value: '',
                      isError: false,
                      id: '',
                      code: 0,
                      message: ''
                    },
                    health_facility_name: {
                      ...prevState['health_facility_name'],
                      value: '',
                      isError: false,
                      id: '',
                      code: 0,
                      message: ''
                    },
                    mobiliser_tagged: {
                      ...prevState['mobiliser_tagged'],
                      value: '',
                      isError: false,
                      id: '',
                      code: 0,
                      message: ''
                    },
                    effective_from_date: {
                      ...prevState['effective_from_dt'],
                      value: "",
                      isError: false,
                    }
                  }))
                  setLinkedFacilityData((prevState) => ({
                    ...prevState,
                    hfr_id: {
                      ...prevState['hfr_id'],
                      '#isDisabled': false
                    },
                    health_facility_type: {
                      ...prevState['health_facility_type'],
                      '#isDisabled': false
                    },
                    health_facility_name: {
                      ...prevState['health_facility_name'],
                      '#isDisabled': false
                    },
                    efective_from_date: {
                      ...prevState['efective_from_date'],
                      '#isDisabled': false
                    }
                  }))
                  handleLinkMultipleFacilities()
                }}
                disabled={userDetails?.user_status === 'Inactive'}
                id={''}
                buttonName={'+ Link Multiple Facilities'}
                colorType={'primary'}
              />
            )}
            {canEditUser && (
              <Button
                disabled={userDetails?.user_status === 'Inactive' || disableShiftTransferBtn}
                id={''}
                buttonName={'Shift/ Transfer'}
                colorType={'primary'}
                onClick={handleShiftTransfer}
              />
            )}
          </div>}

          {!showShiftTransfer && <DataTable
            data={facilityDetails}
            itemsPerPage={[10, 20, 30, 40, 50]}
            pagination={facilityDetails.length > 10}
            searchTerm={''}
            columnHeader={[
              {
                name: 'HFR ID',
                key: 'hfr_id',
                sortable: true,
              },
              {
                name: 'Health Facility Type',
                key: 'facility_type_name',
                sortable: true,
              },
              {
                name: 'Health Facility Name',
                key: 'facility_name',
                sortable: true,
              },
              {
                name: `${isFacilityOrFieldUser === "Facility Level User"?'Asha/ Mobiliser Tagged':'ANM/ Health Provider Tagged'}`,
                key: `${isFacilityOrFieldUser === "Facility Level User"?'mobiliser_name':'health_provider_name'}`,
                sortable: true,
              },
              {
                name: 'Effective From Date',
                key: 'effective_dt',
                sortable: true,
              },
              {
                name: 'Effective To Date',
                key: 'effective_to_dt',
                sortable: true,
              },
              {
                name: 'Actions',
                key: 'Action',
                sortable: false,
              },

            ]}
            gridFor={"healthProviderMaintenance"} />}
        </div>
        {!showShiftTransfer && <hr className='hrMargin' />}
        <div className="upgrade_enrollment">
          {((showEditLinkedFacility|| isLinkingMultipleFacilities) && !showShiftTransfer) &&
            <>
              <BadgesComponent
                className="over-badge"
                badgeName={showEditLinkedFacility? "Edit Linked Multiple Facilities" : "Link Multiple Facilities"}
                variant="primary-1"
                badgeType="case5" />
              <div className="overview-details-update">
                <div className="health_block_page">
                  <form className="container_health_block">
                    <CommonFormFields
                      formData={ showEditLinkedFacility ? linkedFacilityData : healthProviderData}
                      formState={showEditLinkedFacility ? linkedFacilityForm : healthProviderForm}
                      handleFormChange={showEditLinkedFacility ? 
                        handleEditFormChange : 
                        (value: any, key: string,id: any,  option: any, code: any) => {
                          if (key === 'villages_covered' || key === 'wards_covered'||key === 'gram_panchayat_covered'){
                            id = [];
                            option.length > 0 && value.length > 0 && option.forEach((op: any) => {
                              if (value.includes(op.value)) {
                                id.push(op.id);
                              }
                            });
                            code = [];
                            option.length > 0 && value.length > 0 && option.forEach((op: any) => {
                              if (value.includes(op.value)) {
                                code.push(op.code);
                              }
                            });
                          }
        
                          handleFormChange(value, key, id,option,code);
                        }
                      }
                    />
                  </form>
                </div>
              </div>
            </>
          }
          {(showShiftTransfer) &&
            <>
              <BadgesComponent
                className="shift-transfer"
                badgeName="Shift/ Transfer - New Facility Details"
                variant="primary-1"
                badgeType="case5" />
              <div className="hierarchy-details">
                <BadgesComponent
                  className="shift-transfer"
                  badgeName="Hierarchy Details"
                  variant="primary-1"
                  badgeType="case5" />
              </div>
              <div className="shift-transfer-update">
                <div className="shift_transfer_page">
                  <form className="container_shift_transfer">
                    <CommonFormFields
                      formData={shiftTransferData}
                      formState={shiftTransferForm}
                      handleFormChange={handleShiftTransFerFormChange}
                      onInputChange={handleInputChange}
                    />
                  </form>
                </div>
              </div>

              <div className="hierarchy-details">
                <BadgesComponent
                  className="shift-transfer"
                  badgeName="Coverage Details"
                  variant="primary-1"
                  badgeType="case5" />
                <div className="shift-transfer-update">
                  <div className="shift_transfer_page">
                    <form className="container_coverage_details">
                      <CommonFormFields
                        formData={coverageShiftTransferData}
                        formState={coverageShiftTransferForm}
                        handleFormChange={(value: any, key: string,id: any,  option: any, code: any) => {
                        if (key === 'villages_covered' || key === 'wards_covered'||key === 'gram_panchayat_covered'){
                          id = [];
                          option.length > 0 && value.length > 0 && option.forEach((op: any) => {
                            if (value.includes(op.value)) {
                              id.push(op.id);
                            }
                          });
                          code = [];
                          option.length > 0 && value.length > 0 && option.forEach((op: any) => {
                            if (value.includes(op.value)) {
                              code.push(op.code);
                            }
                          });
                        }
      
                        handleShiftTransFerFormChange(value, key, id,option,code);
                      }}
                      />
                    </form>
                  </div>
                </div>
              </div>
            </>
          }
          <div />
        </div>
        {(showEditLinkedFacility || showShiftTransfer || isLinkingMultipleFacilities) && <div className='button_wrapper_bottom'>
          <Button
            onClick={() => {
              setShowMultipleFacilities(false)
              setShowEditLinkedFacility(false);
              //dispatch(updateForm("isEditButtonCLicked", false))
              setLinkedFacilityForm((prevState) => ({
                ...prevState,
                hfr_id: {
                  ...prevState['hfr_id'],
                  value: '',
                  isError: false,
                  id: '',
                  code: 0,
                  message: ''
                },
                health_facility_type: {
                  ...prevState['health_facility_type'],
                  value: '',
                  isError: false,
                  id: '',
                  code: 0,
                  message: ''
                },
                health_facility_name: {
                  ...prevState['health_facility_name'],
                  value: '',
                  isError: false,
                  id: '',
                  code: 0,
                  message: ''
                },
                wards_covered: {
                  ...prevState['wards_covered'],
                  value: [],
                  isError: false,
                  id: [],
                  code: 0,
                  message: ''
                },
                villages_covered: {
                  ...prevState['villages_covered'],
                  value: [],
                  isError: false,
                  id: [],
                  code: 0,
                  message: ''
                },
                gram_panchayat_covered: {
                  ...prevState['gram_panchayat_covered'],
                  value: [],
                  isError: false,
                  id: [],
                  code: 0,
                  message: ''
                },
                mobiliser_tagged: {
                  ...prevState['mobiliser_tagged'],
                  value: '',
                  isError: false,
                  id: '',
                  code: 0,
                  message: ''
                },
                effective_from_date: {
                  ...prevState['effective_from_dt'],
                  value: '',
                  isError: false,
                },
                remarks: {
                  ...prevState['remarks'],
                  value: '',
                  isError: false,
                }
              }));

              handleCancel();
              setShowEditLinkedFacility(false);
              //dispatch(updateForm("isEditButtonCLicked", false));
            }}
            disabled={false}
            id={''}
            buttonName={'Cancel'}
            colorType={'save'} />
          <Button
            onClick={() => {
              showEditLinkedFacility ?
                handleEdit() : isLinkingMultipleFacilities ? handleSaveLinkMultiFacility() : handleSaveShiftTransfer()
            }}
            disabled={false}
            id={''}
            buttonName={'Submit'}
            colorType={'primary'} />
        </div>}
      </div>
    </>)
}
export default UserManagementHealthProvider;
